// @ts-nocheck
import { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountPortalDynamicPageAfterDynamicZoneInput: { input: any; output: any; }
  AccountPortalDynamicPageBeforeDynamicZoneInput: { input: any; output: any; }
  AccountPortalDynamicPageBodyDynamicZoneInput: { input: any; output: any; }
  BlogPostDynamicBodyDynamicZoneInput: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DynamicPageBodyDynamicZoneInput: { input: any; output: any; }
  HomepageBodyDynamicZoneInput: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: {}; output: {}; }
  Long: { input: any; output: any; }
  SpotlightDetailSpotlightContentDynamicZoneInput: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AccountPortalDynamicPage = {
  __typename?: 'AccountPortalDynamicPage';
  after?: Maybe<Array<Maybe<AccountPortalDynamicPageAfterDynamicZone>>>;
  before?: Maybe<Array<Maybe<AccountPortalDynamicPageBeforeDynamicZone>>>;
  body?: Maybe<Array<Maybe<AccountPortalDynamicPageBodyDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AccountPortalDynamicPageRelationResponseCollection>;
  path: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AccountPortalDynamicPageLocalizationsArgs = {
  filters?: InputMaybe<AccountPortalDynamicPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccountPortalDynamicPageAfterDynamicZone = ComponentSharedButton | ComponentSharedContent | ComponentSharedFaq | ComponentSharedHeader | ComponentSharedHeaderVideo | ComponentSharedImage | ComponentSharedParagraph | ComponentSharedSideTextAndImage | ComponentSharedTasksRulesWidget | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedVideo | ComponentSharedYouTubeVideo | Error;

export type AccountPortalDynamicPageBeforeDynamicZone = ComponentSharedButton | ComponentSharedContent | ComponentSharedFaq | ComponentSharedHeader | ComponentSharedImage | ComponentSharedParagraph | ComponentSharedSideTextAndImage | ComponentSharedTasksRulesWidget | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedVideo | ComponentSharedYouTubeVideo | Error;

export type AccountPortalDynamicPageBodyDynamicZone = ComponentSharedButton | ComponentSharedContent | ComponentSharedFaq | ComponentSharedHeader | ComponentSharedImage | ComponentSharedLink | ComponentSharedMedia | ComponentSharedNavbar | ComponentSharedPageNavigation | ComponentSharedParagraph | ComponentSharedSideTextAndImage | ComponentSharedTasksRulesWidget | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedVideo | ComponentSharedYouTubeVideo | Error;

export type AccountPortalDynamicPageEntity = {
  __typename?: 'AccountPortalDynamicPageEntity';
  attributes?: Maybe<AccountPortalDynamicPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AccountPortalDynamicPageEntityResponse = {
  __typename?: 'AccountPortalDynamicPageEntityResponse';
  data?: Maybe<AccountPortalDynamicPageEntity>;
};

export type AccountPortalDynamicPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AccountPortalDynamicPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AccountPortalDynamicPageFiltersInput>;
  not?: InputMaybe<AccountPortalDynamicPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AccountPortalDynamicPageFiltersInput>>>;
  path?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AccountPortalDynamicPageInput = {
  after?: InputMaybe<Array<Scalars['AccountPortalDynamicPageAfterDynamicZoneInput']['input']>>;
  before?: InputMaybe<Array<Scalars['AccountPortalDynamicPageBeforeDynamicZoneInput']['input']>>;
  body?: InputMaybe<Array<Scalars['AccountPortalDynamicPageBodyDynamicZoneInput']['input']>>;
  path?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccountPortalDynamicPageRelationResponseCollection = {
  __typename?: 'AccountPortalDynamicPageRelationResponseCollection';
  data: Array<AccountPortalDynamicPageEntity>;
};

export type Author = {
  __typename?: 'Author';
  SEO?: Maybe<ComponentSharedSeo>;
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AuthorRelationResponseCollection>;
  name: Scalars['String']['output'];
  perex?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<UploadFileRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  socialPlatform?: Maybe<Array<Maybe<ComponentSharedSocialPlatform>>>;
  type?: Maybe<Enum_Author_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AuthorBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AuthorLocalizationsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AuthorProfilePhotoArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AuthorSocialPlatformArgs = {
  filters?: InputMaybe<ComponentSharedSocialPlatformFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AuthorEntity = {
  __typename?: 'AuthorEntity';
  attributes?: Maybe<Author>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AuthorEntityResponse = {
  __typename?: 'AuthorEntityResponse';
  data?: Maybe<AuthorEntity>;
};

export type AuthorFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AuthorFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AuthorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  perex?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  socialPlatform?: InputMaybe<ComponentSharedSocialPlatformFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AuthorInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialPlatform?: InputMaybe<Array<InputMaybe<ComponentSharedSocialPlatformInput>>>;
  type?: InputMaybe<Enum_Author_Type>;
};

export type AuthorRelationResponseCollection = {
  __typename?: 'AuthorRelationResponseCollection';
  data: Array<AuthorEntity>;
};

export type AvatarPart = {
  __typename?: 'AvatarPart';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AvatarPartRelationResponseCollection>;
  partId: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AvatarPartLocalizationsArgs = {
  filters?: InputMaybe<AvatarPartFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AvatarPartEntity = {
  __typename?: 'AvatarPartEntity';
  attributes?: Maybe<AvatarPart>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AvatarPartEntityResponse = {
  __typename?: 'AvatarPartEntityResponse';
  data?: Maybe<AvatarPartEntity>;
};

export type AvatarPartFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AvatarPartFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AvatarPartFiltersInput>;
  not?: InputMaybe<AvatarPartFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AvatarPartFiltersInput>>>;
  partId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AvatarPartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  partId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarPartRelationResponseCollection = {
  __typename?: 'AvatarPartRelationResponseCollection';
  data: Array<AvatarPartEntity>;
};

export type BlogCategory = {
  __typename?: 'BlogCategory';
  SEO: ComponentSharedSeo;
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogCategoryRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogCategoryBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BlogCategoryLocalizationsArgs = {
  filters?: InputMaybe<BlogCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogCategoryEntity = {
  __typename?: 'BlogCategoryEntity';
  attributes?: Maybe<BlogCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogCategoryEntityResponse = {
  __typename?: 'BlogCategoryEntityResponse';
  data?: Maybe<BlogCategoryEntity>;
};

export type BlogCategoryFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogCategoryFiltersInput>;
  not?: InputMaybe<BlogCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogCategoryInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogCategoryRelationResponseCollection = {
  __typename?: 'BlogCategoryRelationResponseCollection';
  data: Array<BlogCategoryEntity>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  SEO: ComponentSharedSeo;
  author?: Maybe<AuthorEntityResponse>;
  blog_category?: Maybe<BlogCategoryEntityResponse>;
  blog_tags?: Maybe<BlogTagRelationResponseCollection>;
  body?: Maybe<Scalars['String']['output']>;
  contentLayers?: Maybe<ComponentSharedContentLayers>;
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dynamicBody?: Maybe<Array<Maybe<BlogPostDynamicBodyDynamicZone>>>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogPostRelationResponseCollection>;
  perex: Scalars['String']['output'];
  publishDate: Scalars['DateTime']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  structuredDataHeadline?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogPostBlog_TagsArgs = {
  filters?: InputMaybe<BlogTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BlogPostLocalizationsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogPostDynamicBodyDynamicZone = ComponentSharedBlogPosts | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHighlights | ComponentSharedLinksCarousel | ComponentSharedLogoClouds | ComponentSharedNavbar | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedRegisterCta | ComponentSharedRoutesSwimline | ComponentSharedSimpleCta | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedTwoColumnsContent | ComponentSharedWorkoutsSwimline | ComponentSharedYouTubeVideo | Error;

export type BlogPostEntity = {
  __typename?: 'BlogPostEntity';
  attributes?: Maybe<BlogPost>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogPostEntityResponse = {
  __typename?: 'BlogPostEntityResponse';
  data?: Maybe<BlogPostEntity>;
};

export type BlogPostFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  author?: InputMaybe<AuthorFiltersInput>;
  blog_category?: InputMaybe<BlogCategoryFiltersInput>;
  blog_tags?: InputMaybe<BlogTagFiltersInput>;
  body?: InputMaybe<StringFilterInput>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogPostFiltersInput>;
  not?: InputMaybe<BlogPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  perex?: InputMaybe<StringFilterInput>;
  publishDate?: InputMaybe<DateTimeFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  structuredDataHeadline?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogPostInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  author?: InputMaybe<Scalars['ID']['input']>;
  blog_category?: InputMaybe<Scalars['ID']['input']>;
  blog_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersInput>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  dynamicBody?: InputMaybe<Array<Scalars['BlogPostDynamicBodyDynamicZoneInput']['input']>>;
  perex?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  structuredDataHeadline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogPostRelationResponseCollection = {
  __typename?: 'BlogPostRelationResponseCollection';
  data: Array<BlogPostEntity>;
};

export type BlogTag = {
  __typename?: 'BlogTag';
  SEO: ComponentSharedSeo;
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogTagRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogTagBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BlogTagLocalizationsArgs = {
  filters?: InputMaybe<BlogTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogTagEntity = {
  __typename?: 'BlogTagEntity';
  attributes?: Maybe<BlogTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogTagEntityResponse = {
  __typename?: 'BlogTagEntityResponse';
  data?: Maybe<BlogTagEntity>;
};

export type BlogTagFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BlogTagFiltersInput>>>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogTagFiltersInput>;
  not?: InputMaybe<BlogTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogTagFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogTagInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogTagRelationResponseCollection = {
  __typename?: 'BlogTagRelationResponseCollection';
  data: Array<BlogTagEntity>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Branding = {
  __typename?: 'Branding';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  logo: UploadFileEntityResponse;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BrandingEntity = {
  __typename?: 'BrandingEntity';
  attributes?: Maybe<Branding>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BrandingEntityResponse = {
  __typename?: 'BrandingEntityResponse';
  data?: Maybe<BrandingEntity>;
};

export type BrandingEntityResponseCollection = {
  __typename?: 'BrandingEntityResponseCollection';
  data: Array<BrandingEntity>;
  meta: ResponseCollectionMeta;
};

export type BrandingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BrandingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<BrandingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BrandingFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BrandingInput = {
  logo?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Challenge = {
  __typename?: 'Challenge';
  SEO?: Maybe<ComponentSharedSeo>;
  availableFrom?: Maybe<Scalars['DateTime']['output']>;
  availableTo?: Maybe<Scalars['DateTime']['output']>;
  badgeToReward?: Maybe<Scalars['JSON']['output']>;
  carousels?: Maybe<Array<Maybe<ComponentSharedSimpleCardsWidget>>>;
  challengeId: Scalars['ID']['output'];
  contents?: Maybe<Array<Maybe<ComponentSharedTextWidget>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailDescription?: Maybe<Scalars['String']['output']>;
  expandTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ChallengeRelationResponseCollection>;
  longDescription?: Maybe<Scalars['String']['output']>;
  prizes?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tasksAndRules?: Maybe<Array<Maybe<ComponentSharedTasksRulesWidget>>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  winners?: Maybe<Array<Maybe<ComponentWinnableWinner>>>;
  youTubeVideoId?: Maybe<Scalars['String']['output']>;
};


export type ChallengeCarouselsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeContentsArgs = {
  filters?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeLocalizationsArgs = {
  filters?: InputMaybe<ChallengeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengePrizesArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeTasksAndRulesArgs = {
  filters?: InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeWinnersArgs = {
  filters?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChallengeEntity = {
  __typename?: 'ChallengeEntity';
  attributes?: Maybe<Challenge>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ChallengeEntityResponse = {
  __typename?: 'ChallengeEntityResponse';
  data?: Maybe<ChallengeEntity>;
};

export type ChallengeFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ChallengeFiltersInput>>>;
  availableFrom?: InputMaybe<DateTimeFilterInput>;
  availableTo?: InputMaybe<DateTimeFilterInput>;
  badgeToReward?: InputMaybe<JsonFilterInput>;
  carousels?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  challengeId?: InputMaybe<StringFilterInput>;
  contents?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  detailDescription?: InputMaybe<StringFilterInput>;
  endDateTime?: InputMaybe<DateTimeFilterInput>;
  expandTitle?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ChallengeFiltersInput>;
  longDescription?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ChallengeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ChallengeFiltersInput>>>;
  prizes?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  tasksAndRules?: InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  winners?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  youTubeVideoId?: InputMaybe<StringFilterInput>;
};

export type ChallengeInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableTo?: InputMaybe<Scalars['DateTime']['input']>;
  badgeToReward?: InputMaybe<Scalars['JSON']['input']>;
  carousels?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetInput>>>;
  challengeId?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailDescription?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  expandTitle?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  prizes?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tasksAndRules?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesWidgetInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  winners?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerInput>>>;
  youTubeVideoId?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeRelationResponseCollection = {
  __typename?: 'ChallengeRelationResponseCollection';
  data: Array<ChallengeEntity>;
};

export type ComponentSharedAuthors = {
  __typename?: 'ComponentSharedAuthors';
  authorsByType: Array<Maybe<Author>>;
  id: Scalars['ID']['output'];
  type?: Maybe<Enum_Componentsharedauthors_Type>;
};

export type ComponentSharedBlogPosts = {
  __typename?: 'ComponentSharedBlogPosts';
  anchorId?: Maybe<Scalars['String']['output']>;
  blogPosts?: Maybe<BlogPostRelationResponseCollection>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedBlogPostsBlogPostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedBlogPostsFiltersInput = {
  anchorId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedBlogPostsFiltersInput>>>;
  blogPosts?: InputMaybe<BlogPostFiltersInput>;
  expand?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedBlogPostsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedBlogPostsFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedBlogPostsInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  blogPosts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  expand?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedButton = {
  __typename?: 'ComponentSharedButton';
  buttonStyle?: Maybe<Enum_Componentsharedbutton_Buttonstyle>;
  buttonType?: Maybe<Enum_Componentsharedbutton_Buttontype>;
  ctaEvent?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ComponentSharedButtonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedButtonFiltersInput>>>;
  buttonStyle?: InputMaybe<StringFilterInput>;
  buttonType?: InputMaybe<StringFilterInput>;
  ctaEvent?: InputMaybe<StringFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedButtonFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedButtonInput = {
  buttonStyle?: InputMaybe<Enum_Componentsharedbutton_Buttonstyle>;
  buttonType?: InputMaybe<Enum_Componentsharedbutton_Buttontype>;
  ctaEvent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedCancelPageSlide = {
  __typename?: 'ComponentSharedCancelPageSlide';
  backgroundMedia?: Maybe<ComponentSharedMedia>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Enum_Componentsharedcancelpageslide_Type;
};

export type ComponentSharedCancelPageSlideFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedCancelPageSlideFiltersInput>>>;
  backgroundMedia?: InputMaybe<ComponentSharedMediaFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedCancelPageSlideFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedCancelPageSlideFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedCancelPageSlideInput = {
  backgroundMedia?: InputMaybe<ComponentSharedMediaInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Componentsharedcancelpageslide_Type>;
};

export type ComponentSharedCard = {
  __typename?: 'ComponentSharedCard';
  button?: Maybe<ComponentSharedButton>;
  buttonAlt?: Maybe<ComponentSharedButton>;
  contentImage?: Maybe<UploadFileEntityResponse>;
  contentText?: Maybe<Scalars['String']['output']>;
  contentTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSharedCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedCardFiltersInput>>>;
  button?: InputMaybe<ComponentSharedButtonFiltersInput>;
  buttonAlt?: InputMaybe<ComponentSharedButtonFiltersInput>;
  contentText?: InputMaybe<StringFilterInput>;
  contentTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedCardFiltersInput>>>;
};

export type ComponentSharedChallenges = {
  __typename?: 'ComponentSharedChallenges';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  challenges?: Maybe<ChallengeRelationResponseCollection>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedChallengesChallengesArgs = {
  filters?: InputMaybe<ChallengeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedChecklist = {
  __typename?: 'ComponentSharedChecklist';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Scalars['String']['output'];
  title: Scalars['String']['output'];
  vertical?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentSharedCompanionAppCta = {
  __typename?: 'ComponentSharedCompanionAppCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};


export type ComponentSharedCompanionAppCtaButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedContent = {
  __typename?: 'ComponentSharedContent';
  card?: Maybe<Array<Maybe<ComponentSharedCard>>>;
  id: Scalars['ID']['output'];
};


export type ComponentSharedContentCardArgs = {
  filters?: InputMaybe<ComponentSharedCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedContentCard = {
  __typename?: 'ComponentSharedContentCard';
  contentId: Scalars['String']['output'];
  contentType: Enum_Componentsharedcontentcard_Contenttype;
  id: Scalars['ID']['output'];
};

export type ComponentSharedContentCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedContentCardFiltersInput>>>;
  contentId?: InputMaybe<StringFilterInput>;
  contentType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedContentCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedContentCardFiltersInput>>>;
};

export type ComponentSharedContentCardInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Enum_Componentsharedcontentcard_Contenttype>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedContentLayers = {
  __typename?: 'ComponentSharedContentLayers';
  aim: Enum_Componentsharedcontentlayers_Aim;
  contentType: Enum_Componentsharedcontentlayers_Contenttype;
  id: Scalars['ID']['output'];
  perspective: Enum_Componentsharedcontentlayers_Perspective;
  segment: Scalars['JSON']['output'];
};

export type ComponentSharedContentLayersFiltersInput = {
  aim?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedContentLayersFiltersInput>>>;
  contentType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedContentLayersFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedContentLayersFiltersInput>>>;
  perspective?: InputMaybe<StringFilterInput>;
  segment?: InputMaybe<JsonFilterInput>;
};

export type ComponentSharedContentLayersInput = {
  aim?: InputMaybe<Enum_Componentsharedcontentlayers_Aim>;
  contentType?: InputMaybe<Enum_Componentsharedcontentlayers_Contenttype>;
  id?: InputMaybe<Scalars['ID']['input']>;
  perspective?: InputMaybe<Enum_Componentsharedcontentlayers_Perspective>;
  segment?: InputMaybe<Scalars['JSON']['input']>;
};

export type ComponentSharedContentSwimlane = {
  __typename?: 'ComponentSharedContentSwimlane';
  anchorId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<Maybe<ComponentSharedContentCard>>>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedContentSwimlaneContentArgs = {
  filters?: InputMaybe<ComponentSharedContentCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedContentTeaser = {
  __typename?: 'ComponentSharedContentTeaser';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  backgroundImageResponsive?: Maybe<UploadFileEntityResponse>;
  cards?: Maybe<Array<Maybe<ComponentSharedSimpleCard>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<UploadFileEntityResponse>;
  logoResponsive?: Maybe<UploadFileEntityResponse>;
  size: Enum_Componentsharedcontentteaser_Size;
  title: Scalars['String']['output'];
};


export type ComponentSharedContentTeaserCardsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedEvents = {
  __typename?: 'ComponentSharedEvents';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  category?: Maybe<Scalars['String']['output']>;
  eventInfos?: Maybe<EventInfoRelationResponseCollection>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  featuredEventInfos: Array<Maybe<EventInfo>>;
  filterEventInfos: Array<Maybe<EventInfo>>;
  id: Scalars['ID']['output'];
  inverted?: Maybe<Scalars['Boolean']['output']>;
  logosStrip?: Maybe<UploadFileRelationResponseCollection>;
  subcategory?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedEventsEventInfosArgs = {
  filters?: InputMaybe<EventInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSharedEventsLogosStripArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedFaq = {
  __typename?: 'ComponentSharedFaq';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  id: Scalars['ID']['output'];
  question?: Maybe<Array<Maybe<ComponentSharedQuestion>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedFaqQuestionArgs = {
  filters?: InputMaybe<ComponentSharedQuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedFeaturedLogo = {
  __typename?: 'ComponentSharedFeaturedLogo';
  id: Scalars['ID']['output'];
  logo: ComponentSharedLogo;
  title: Scalars['String']['output'];
};

export type ComponentSharedHeader = {
  __typename?: 'ComponentSharedHeader';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  button?: Maybe<ComponentSharedButton>;
  buttonAlt?: Maybe<ComponentSharedButton>;
  campaignId?: Maybe<Scalars['String']['output']>;
  cdnBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  cdnVideoUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  linkAfterEmailSubmit?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<UploadFileEntityResponse>;
  logosStrip?: Maybe<UploadFileRelationResponseCollection>;
  responsiveImage?: Maybe<UploadFileEntityResponse>;
  subheading?: Maybe<Scalars['String']['output']>;
  textLogo?: Maybe<Scalars['String']['output']>;
  video?: Maybe<UploadFileEntityResponse>;
};


export type ComponentSharedHeaderLogosStripArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedHeaderAcceptInvite = {
  __typename?: 'ComponentSharedHeaderAcceptInvite';
  backgroundImage: UploadFileEntityResponse;
  button: ComponentSharedButton;
  buttonFallback?: Maybe<ComponentSharedButton>;
  heading: Scalars['String']['output'];
  headingFallback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subheading: Scalars['String']['output'];
  subheadingFallback?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedHeaderVideo = {
  __typename?: 'ComponentSharedHeaderVideo';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  campaingId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subheading?: Maybe<Scalars['String']['output']>;
  video: ComponentSharedVideo;
  videoResponsive?: Maybe<ComponentSharedVideo>;
};


export type ComponentSharedHeaderVideoButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedHighlights = {
  __typename?: 'ComponentSharedHighlights';
  Highlight?: Maybe<Array<Maybe<ComponentSharedCard>>>;
  Layout?: Maybe<Enum_Componentsharedhighlights_Layout>;
  Title?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedHighlightsHighlightArgs = {
  filters?: InputMaybe<ComponentSharedCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedImage = {
  __typename?: 'ComponentSharedImage';
  caption: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
};

export type ComponentSharedImageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedImageFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedImageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedImageFiltersInput>>>;
};

export type ComponentSharedImageInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedLink = {
  __typename?: 'ComponentSharedLink';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ComponentSharedLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLinkFiltersInput>>>;
  not?: InputMaybe<ComponentSharedLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLinkFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedLinkInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedLinksCarousel = {
  __typename?: 'ComponentSharedLinksCarousel';
  LinksCarouselItem?: Maybe<Array<Maybe<ComponentSharedLinksCarouselItem>>>;
  anchorId?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Enum_Componentsharedlinkscarousel_Background>;
  buttonClickThrough?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedLinksCarouselLinksCarouselItemArgs = {
  filters?: InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedLinksCarouselItem = {
  __typename?: 'ComponentSharedLinksCarouselItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  label?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedLinksCarouselItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedLinksGroup = {
  __typename?: 'ComponentSharedLinksGroup';
  id: Scalars['ID']['output'];
  links: Array<Maybe<ComponentSharedLink>>;
  title: Scalars['String']['output'];
};


export type ComponentSharedLinksGroupLinksArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedLinksGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLinksGroupFiltersInput>>>;
  links?: InputMaybe<ComponentSharedLinkFiltersInput>;
  not?: InputMaybe<ComponentSharedLinksGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLinksGroupFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedLinksGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedLogo = {
  __typename?: 'ComponentSharedLogo';
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  link?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedLogoClouds = {
  __typename?: 'ComponentSharedLogoClouds';
  id: Scalars['ID']['output'];
  logos: Array<Maybe<ComponentSharedLogo>>;
  title: Scalars['String']['output'];
};


export type ComponentSharedLogoCloudsLogosArgs = {
  filters?: InputMaybe<ComponentSharedLogoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedLogoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLogoFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedLogoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLogoFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedMedia = {
  __typename?: 'ComponentSharedMedia';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedMediaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMediaFiltersInput>>>;
  not?: InputMaybe<ComponentSharedMediaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMediaFiltersInput>>>;
  youtubeVideoId?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedMediaInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  youtubeVideoId?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedNavbar = {
  __typename?: 'ComponentSharedNavbar';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  navbarItems?: Maybe<Array<Maybe<ComponentSharedNavbarItem>>>;
};


export type ComponentSharedNavbarNavbarItemsArgs = {
  filters?: InputMaybe<ComponentSharedNavbarItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedNavbarItem = {
  __typename?: 'ComponentSharedNavbarItem';
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  path: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSharedNavbarItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarItemFiltersInput>>>;
  not?: InputMaybe<ComponentSharedNavbarItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarItemFiltersInput>>>;
  path?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedNavbarSettings = {
  __typename?: 'ComponentSharedNavbarSettings';
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  fixed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  logoLink?: Maybe<ComponentSharedLink>;
  navLinks?: Maybe<Array<Maybe<ComponentSharedLink>>>;
  secondaryLogo?: Maybe<UploadFileEntityResponse>;
  secondaryLogoLink?: Maybe<Scalars['String']['output']>;
  transparent?: Maybe<Scalars['Boolean']['output']>;
};


export type ComponentSharedNavbarSettingsButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSharedNavbarSettingsNavLinksArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedNavbarSettingsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarSettingsFiltersInput>>>;
  buttons?: InputMaybe<ComponentSharedButtonFiltersInput>;
  fixed?: InputMaybe<BooleanFilterInput>;
  logoLink?: InputMaybe<ComponentSharedLinkFiltersInput>;
  navLinks?: InputMaybe<ComponentSharedLinkFiltersInput>;
  not?: InputMaybe<ComponentSharedNavbarSettingsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarSettingsFiltersInput>>>;
  secondaryLogoLink?: InputMaybe<StringFilterInput>;
  transparent?: InputMaybe<BooleanFilterInput>;
};

export type ComponentSharedNavbarSettingsInput = {
  buttons?: InputMaybe<Array<InputMaybe<ComponentSharedButtonInput>>>;
  fixed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoLink?: InputMaybe<ComponentSharedLinkInput>;
  navLinks?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>;
  secondaryLogo?: InputMaybe<Scalars['ID']['input']>;
  secondaryLogoLink?: InputMaybe<Scalars['String']['input']>;
  transparent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentSharedNewsletterCta = {
  __typename?: 'ComponentSharedNewsletterCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  formType?: Maybe<Enum_Componentsharednewslettercta_Formtype>;
  hint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  visual?: Maybe<UploadFileEntityResponse>;
};

export type ComponentSharedPageNavigation = {
  __typename?: 'ComponentSharedPageNavigation';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedPageNavigationButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedParagraph = {
  __typename?: 'ComponentSharedParagraph';
  asset?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedParagraphFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedParagraphFiltersInput>>>;
  not?: InputMaybe<ComponentSharedParagraphFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedParagraphFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  youtubeLink?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedParagraphInput = {
  asset?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedPlansSelector = {
  __typename?: 'ComponentSharedPlansSelector';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  id: Scalars['ID']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  termsSection?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedPricing = {
  __typename?: 'ComponentSharedPricing';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkAfterEmailSubmit?: Maybe<Scalars['String']['output']>;
  monthly: Scalars['Boolean']['output'];
  plan: Enum_Componentsharedpricing_Plan;
  termsSection?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  yearlyToMonths?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentSharedPrizes = {
  __typename?: 'ComponentSharedPrizes';
  Button?: Maybe<ComponentSharedButton>;
  Prizes?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  Title?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentSharedPrizesPrizesArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedProductsComparison = {
  __typename?: 'ComponentSharedProductsComparison';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  featuresTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productsJson?: Maybe<Scalars['JSON']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedQuestion = {
  __typename?: 'ComponentSharedQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  questionText?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedQuestionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedQuestionFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedQuestionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedQuestionFiltersInput>>>;
  questionText?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedRegisterCta = {
  __typename?: 'ComponentSharedRegisterCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  linkAfterEmailSubmit?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedRouteCreator = {
  __typename?: 'ComponentSharedRouteCreator';
  firebaseUid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSharedRouteCreatorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedRouteCreatorFiltersInput>>>;
  firebaseUid?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedRouteCreatorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedRouteCreatorFiltersInput>>>;
};

export type ComponentSharedRouteCreatorInput = {
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedRoutes = {
  __typename?: 'ComponentSharedRoutes';
  id: Scalars['ID']['output'];
  ids?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedRoutesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedRoutesFiltersInput>>>;
  ids?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedRoutesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedRoutesFiltersInput>>>;
};

export type ComponentSharedRoutesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedRoutesSection = {
  __typename?: 'ComponentSharedRoutesSection';
  anchorId?: Maybe<Scalars['String']['output']>;
  categorySlug?: Maybe<Scalars['String']['output']>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  logosStrip?: Maybe<UploadFileRelationResponseCollection>;
  offset?: Maybe<Scalars['Int']['output']>;
  routeIds?: Maybe<ComponentSharedRoutes>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Enum_Componentsharedroutessection_Type>;
};


export type ComponentSharedRoutesSectionLogosStripArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedRoutesSwimline = {
  __typename?: 'ComponentSharedRoutesSwimline';
  anchorId?: Maybe<Scalars['String']['output']>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  logosStrip?: Maybe<UploadFileRelationResponseCollection>;
  routes?: Maybe<RouteCardRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedRoutesSwimlineLogosStripArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSharedRoutesSwimlineRoutesArgs = {
  filters?: InputMaybe<RouteCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  id: Scalars['ID']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  noFollow?: Maybe<Scalars['Boolean']['output']>;
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  shareImage?: Maybe<UploadFileEntityResponse>;
};

export type ComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  noFollow?: InputMaybe<BooleanFilterInput>;
  noIndex?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentSharedSeoFiltersInput>;
  ogTitle?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
};

export type ComponentSharedSeoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  shareImage?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedSideTextAndImage = {
  __typename?: 'ComponentSharedSideTextAndImage';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  imageOnRightSide?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedSimpleCard = {
  __typename?: 'ComponentSharedSimpleCard';
  cover: UploadFileEntityResponse;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedSimpleCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSimpleCardInput = {
  cover?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedSimpleCardsWidget = {
  __typename?: 'ComponentSharedSimpleCardsWidget';
  cards: Array<Maybe<ComponentSharedSimpleCard>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};


export type ComponentSharedSimpleCardsWidgetCardsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedSimpleCardsWidgetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>>>;
  cards?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSimpleCardsWidgetInput = {
  cards?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedSimpleCta = {
  __typename?: 'ComponentSharedSimpleCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  button: ComponentSharedButton;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
};

export type ComponentSharedSocialPlatform = {
  __typename?: 'ComponentSharedSocialPlatform';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  type: Enum_Componentsharedsocialplatform_Type;
};

export type ComponentSharedSocialPlatformFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSocialPlatformFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSocialPlatformFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSocialPlatformFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSocialPlatformInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Componentsharedsocialplatform_Type>;
};

export type ComponentSharedSpotlight = {
  __typename?: 'ComponentSharedSpotlight';
  card?: Maybe<ComponentSharedSimpleCard>;
  challenge?: Maybe<ChallengeEntityResponse>;
  eventInfo?: Maybe<EventInfoEntityResponse>;
  id: Scalars['ID']['output'];
  routeId?: Maybe<Scalars['Int']['output']>;
  trainingPlanId?: Maybe<Scalars['Int']['output']>;
  workoutId?: Maybe<Scalars['Int']['output']>;
};

export type ComponentSharedSpotlightFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSpotlightFiltersInput>>>;
  card?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  challenge?: InputMaybe<ChallengeFiltersInput>;
  eventInfo?: InputMaybe<EventInfoFiltersInput>;
  not?: InputMaybe<ComponentSharedSpotlightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSpotlightFiltersInput>>>;
  routeId?: InputMaybe<IntFilterInput>;
  trainingPlanId?: InputMaybe<IntFilterInput>;
  workoutId?: InputMaybe<IntFilterInput>;
};

export type ComponentSharedSpotlightInput = {
  card?: InputMaybe<ComponentSharedSimpleCardInput>;
  challenge?: InputMaybe<Scalars['ID']['input']>;
  eventInfo?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  trainingPlanId?: InputMaybe<Scalars['Int']['input']>;
  workoutId?: InputMaybe<Scalars['Int']['input']>;
};

export type ComponentSharedSpotlights = {
  __typename?: 'ComponentSharedSpotlights';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  spotlight?: Maybe<SpotlightEntityResponse>;
};

export type ComponentSharedSpotlightsList = {
  __typename?: 'ComponentSharedSpotlightsList';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  spotlights?: Maybe<SpotlightRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedSpotlightsListSpotlightsArgs = {
  filters?: InputMaybe<SpotlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedStepCard = {
  __typename?: 'ComponentSharedStepCard';
  alternativeImage?: Maybe<UploadFileEntityResponse>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedStepCardButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedStepCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedStepCardFiltersInput>>>;
  buttons?: InputMaybe<ComponentSharedButtonFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedStepCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedStepCardFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSteps = {
  __typename?: 'ComponentSharedSteps';
  alternativeTitle?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  disableNumbering?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  step?: Maybe<Array<Maybe<ComponentSharedStepCard>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedStepsStepArgs = {
  filters?: InputMaybe<ComponentSharedStepCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedStripe = {
  __typename?: 'ComponentSharedStripe';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Enum_Componentsharedstripe_Backgroundcolor>;
  id: Scalars['ID']['output'];
  lowerBackgroundColor?: Maybe<Enum_Componentsharedstripe_Lowerbackgroundcolor>;
  textColor?: Maybe<Enum_Componentsharedstripe_Textcolor>;
  title: Scalars['String']['output'];
  titleSecondLine?: Maybe<Scalars['String']['output']>;
  upperBackgroundColor?: Maybe<Enum_Componentsharedstripe_Upperbackgroundcolor>;
};

export type ComponentSharedTasksRulesCard = {
  __typename?: 'ComponentSharedTasksRulesCard';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSharedTasksRulesCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesCardFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedTasksRulesCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesCardFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTasksRulesCardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTasksRulesWidget = {
  __typename?: 'ComponentSharedTasksRulesWidget';
  cards?: Maybe<Array<Maybe<ComponentSharedTasksRulesCard>>>;
  id: Scalars['ID']['output'];
  routes?: Maybe<ComponentSharedRoutes>;
  subtitle?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  workouts?: Maybe<ComponentSharedWorkouts>;
};


export type ComponentSharedTasksRulesWidgetCardsArgs = {
  filters?: InputMaybe<ComponentSharedTasksRulesCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedTasksRulesWidgetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>>>;
  cards?: InputMaybe<ComponentSharedTasksRulesCardFiltersInput>;
  not?: InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>>>;
  routes?: InputMaybe<ComponentSharedRoutesFiltersInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  workouts?: InputMaybe<ComponentSharedWorkoutsFiltersInput>;
};

export type ComponentSharedTasksRulesWidgetInput = {
  cards?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesCardInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  routes?: InputMaybe<ComponentSharedRoutesInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workouts?: InputMaybe<ComponentSharedWorkoutsInput>;
};

export type ComponentSharedTestimonial = {
  __typename?: 'ComponentSharedTestimonial';
  author: Scalars['String']['output'];
  authorType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  testimonial: Scalars['String']['output'];
};

export type ComponentSharedTestimonialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTestimonialFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  authorType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedTestimonialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTestimonialFiltersInput>>>;
  testimonial?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTestimonialsSection = {
  __typename?: 'ComponentSharedTestimonialsSection';
  anchorId?: Maybe<Scalars['String']['output']>;
  autoscrollInterval: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  testimonials: Array<Maybe<ComponentSharedTestimonial>>;
};


export type ComponentSharedTestimonialsSectionTestimonialsArgs = {
  filters?: InputMaybe<ComponentSharedTestimonialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedTextBlock = {
  __typename?: 'ComponentSharedTextBlock';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentSharedTextWidget = {
  __typename?: 'ComponentSharedTextWidget';
  carousel?: Maybe<Array<Maybe<ComponentSharedImage>>>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ComponentSharedTextWidgetCarouselArgs = {
  filters?: InputMaybe<ComponentSharedImageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedTextWidgetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetFiltersInput>>>;
  carousel?: InputMaybe<ComponentSharedImageFiltersInput>;
  not?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTextWidgetInput = {
  carousel?: InputMaybe<Array<InputMaybe<ComponentSharedImageInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTwoColumnsContent = {
  __typename?: 'ComponentSharedTwoColumnsContent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedVideo = {
  __typename?: 'ComponentSharedVideo';
  autoPlay: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  loop: Scalars['Boolean']['output'];
  muted: Scalars['Boolean']['output'];
  showControls: Scalars['Boolean']['output'];
  showVideo: Enum_Componentsharedvideo_Showvideo;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  video: UploadFileEntityResponse;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedWorkouts = {
  __typename?: 'ComponentSharedWorkouts';
  id: Scalars['ID']['output'];
  ids?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedWorkoutsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedWorkoutsFiltersInput>>>;
  ids?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedWorkoutsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedWorkoutsFiltersInput>>>;
};

export type ComponentSharedWorkoutsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedWorkoutsSection = {
  __typename?: 'ComponentSharedWorkoutsSection';
  anchorId?: Maybe<Scalars['String']['output']>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  workouts?: Maybe<ComponentSharedWorkouts>;
};

export type ComponentSharedWorkoutsSwimline = {
  __typename?: 'ComponentSharedWorkoutsSwimline';
  anchorId?: Maybe<Scalars['String']['output']>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  workouts?: Maybe<WorkoutCardRelationResponseCollection>;
};


export type ComponentSharedWorkoutsSwimlineWorkoutsArgs = {
  filters?: InputMaybe<WorkoutCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedYouTubeVideo = {
  __typename?: 'ComponentSharedYouTubeVideo';
  anchorId?: Maybe<Scalars['String']['output']>;
  caption: Scalars['String']['output'];
  cover?: Maybe<UploadFileEntityResponse>;
  embedCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedYouTubeVideoFiltersInput = {
  anchorId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedYouTubeVideoFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  embedCode?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedYouTubeVideoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedYouTubeVideoFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  videoUrl?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedYouTubeVideoInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  embedCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentWinnablePrize = {
  __typename?: 'ComponentWinnablePrize';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  winner?: Maybe<ComponentWinnableWinner>;
};

export type ComponentWinnablePrizeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  winner?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
};

export type ComponentWinnablePrizeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<ComponentWinnableWinnerInput>;
};

export type ComponentWinnableWinner = {
  __typename?: 'ComponentWinnableWinner';
  id: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type ComponentWinnableWinnerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerFiltersInput>>>;
  not?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerFiltersInput>>>;
  userName?: InputMaybe<StringFilterInput>;
};

export type ComponentWinnableWinnerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DynamicPage = {
  __typename?: 'DynamicPage';
  SEO: ComponentSharedSeo;
  body?: Maybe<Array<Maybe<DynamicPageBodyDynamicZone>>>;
  contentLayers?: Maybe<ComponentSharedContentLayers>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<DynamicPageRelationResponseCollection>;
  navbarSettings?: Maybe<ComponentSharedNavbarSettings>;
  path: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  structuredDataHeadline?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DynamicPageLocalizationsArgs = {
  filters?: InputMaybe<DynamicPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DynamicPageBodyDynamicZone = ComponentSharedAuthors | ComponentSharedBlogPosts | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedContentTeaser | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHeader | ComponentSharedHeaderAcceptInvite | ComponentSharedHeaderVideo | ComponentSharedHighlights | ComponentSharedLinksCarousel | ComponentSharedLogoClouds | ComponentSharedNavbar | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedRegisterCta | ComponentSharedRoutesSwimline | ComponentSharedSimpleCta | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedTwoColumnsContent | ComponentSharedWorkoutsSwimline | ComponentSharedYouTubeVideo | Error;

export type DynamicPageEntity = {
  __typename?: 'DynamicPageEntity';
  attributes?: Maybe<DynamicPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DynamicPageEntityResponse = {
  __typename?: 'DynamicPageEntityResponse';
  data?: Maybe<DynamicPageEntity>;
};

export type DynamicPageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<DynamicPageFiltersInput>>>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<DynamicPageFiltersInput>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsFiltersInput>;
  not?: InputMaybe<DynamicPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DynamicPageFiltersInput>>>;
  path?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  structuredDataHeadline?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DynamicPageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  body?: InputMaybe<Array<Scalars['DynamicPageBodyDynamicZoneInput']['input']>>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersInput>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  structuredDataHeadline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicPageRelationResponseCollection = {
  __typename?: 'DynamicPageRelationResponseCollection';
  data: Array<DynamicPageEntity>;
};

export enum Enum_Author_Type {
  Author = 'author',
  Director = 'director',
  ExternalAuthor = 'externalAuthor'
}

export enum Enum_Componentsharedauthors_Type {
  Author = 'author',
  Director = 'director',
  ExternalAuthor = 'externalAuthor'
}

export enum Enum_Componentsharedbutton_Buttonstyle {
  Alternative = 'alternative',
  Danger = 'danger',
  Primary = 'primary',
  Secondary = 'secondary',
  Subtle = 'subtle'
}

export enum Enum_Componentsharedbutton_Buttontype {
  Default = 'default',
  Download = 'download',
  StravaConnect = 'stravaConnect',
  StravaPremium = 'stravaPremium'
}

export enum Enum_Componentsharedcancelpageslide_Type {
  Challenges = 'CHALLENGES',
  Events = 'EVENTS',
  Header = 'HEADER',
  Measurements = 'MEASUREMENTS'
}

export enum Enum_Componentsharedcontentcard_Contenttype {
  Challenge = 'challenge',
  Event = 'event',
  Route = 'route',
  TrainingPlan = 'training_plan',
  Workout = 'workout'
}

export enum Enum_Componentsharedcontentlayers_Aim {
  Acquisition = 'acquisition',
  Brand = 'brand',
  Education = 'education',
  Reactivation = 'reactivation'
}

export enum Enum_Componentsharedcontentlayers_Contenttype {
  Blog = 'blog',
  General = 'general',
  Help = 'help',
  Lp = 'lp',
  PaidBrand = 'paidBrand',
  Perf = 'perf',
  Press = 'press'
}

export enum Enum_Componentsharedcontentlayers_Perspective {
  Benefits = 'benefits',
  Event = 'event',
  Feature = 'feature',
  General = 'general',
  Help = 'help',
  Solutions = 'solutions'
}

export enum Enum_Componentsharedcontentteaser_Size {
  Large = 'large',
  Small = 'small'
}

export enum Enum_Componentsharedhighlights_Layout {
  AlternateLeft = 'alternate_left',
  AlternateRight = 'alternate_right',
  Left = 'left',
  Right = 'right'
}

export enum Enum_Componentsharedlinkscarousel_Background {
  None = 'none',
  Pattern_1 = 'pattern_1',
  Pattern_1b = 'pattern_1b',
  Pattern_2 = 'pattern_2',
  Pattern_3 = 'pattern_3'
}

export enum Enum_Componentsharednewslettercta_Formtype {
  Affil = 'affil',
  Newsletter = 'newsletter',
  Trial = 'trial'
}

export enum Enum_Componentsharedpricing_Plan {
  RouvyDuo = 'rouvy_duo',
  RouvyGroup = 'rouvy_group',
  RouvySingle = 'rouvy_single'
}

export enum Enum_Componentsharedroutessection_Type {
  New = 'new',
  Other = 'other',
  Recommended = 'recommended'
}

export enum Enum_Componentsharedsocialplatform_Type {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Rouvy = 'rouvy',
  Strava = 'strava',
  X = 'x'
}

export enum Enum_Componentsharedstripe_Backgroundcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedstripe_Lowerbackgroundcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedstripe_Textcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedstripe_Upperbackgroundcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedvideo_Showvideo {
  OnClick = 'on_click',
  OnHover = 'on_hover',
  OnLoad = 'on_load'
}

export enum Enum_Post_Category {
  News = 'NEWS',
  Press = 'PRESS'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type EventInfo = {
  __typename?: 'EventInfo';
  brandPhoto?: Maybe<UploadFileEntityResponse>;
  carousels?: Maybe<Array<Maybe<ComponentSharedSimpleCardsWidget>>>;
  category?: Maybe<Scalars['String']['output']>;
  contents?: Maybe<Array<Maybe<ComponentSharedTextWidget>>>;
  coverPhoto?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultSessionId?: Maybe<Scalars['String']['output']>;
  defaultSessionStartDateTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  expandTitle?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<EventInfoRelationResponseCollection>;
  longDescription?: Maybe<Scalars['String']['output']>;
  mainMedia?: Maybe<ComponentSharedMedia>;
  mainPhoto?: Maybe<UploadFileEntityResponse>;
  prizes?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  routeCard?: Maybe<RouteCardEntityResponse>;
  subcategory?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: EventInfoType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  winners?: Maybe<Array<Maybe<ComponentWinnableWinner>>>;
};


export type EventInfoCarouselsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoContentsArgs = {
  filters?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoLocalizationsArgs = {
  filters?: InputMaybe<EventInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoPrizesArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoWinnersArgs = {
  filters?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventInfoEntity = {
  __typename?: 'EventInfoEntity';
  attributes?: Maybe<EventInfo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EventInfoEntityResponse = {
  __typename?: 'EventInfoEntityResponse';
  data?: Maybe<EventInfoEntity>;
};

export type EventInfoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventInfoFiltersInput>>>;
  carousels?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  category?: InputMaybe<StringFilterInput>;
  contents?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  defaultSessionId?: InputMaybe<StringFilterInput>;
  defaultSessionStartDateTimeUtc?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  eventId?: InputMaybe<StringFilterInput>;
  expandTitle?: InputMaybe<StringFilterInput>;
  featured?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EventInfoFiltersInput>;
  longDescription?: InputMaybe<StringFilterInput>;
  mainMedia?: InputMaybe<ComponentSharedMediaFiltersInput>;
  not?: InputMaybe<EventInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventInfoFiltersInput>>>;
  prizes?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  routeCard?: InputMaybe<RouteCardFiltersInput>;
  subcategory?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  winners?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
};

export type EventInfoInput = {
  brandPhoto?: InputMaybe<Scalars['ID']['input']>;
  carousels?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetInput>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetInput>>>;
  coverPhoto?: InputMaybe<Scalars['ID']['input']>;
  defaultSessionId?: InputMaybe<Scalars['String']['input']>;
  defaultSessionStartDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  expandTitle?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  mainMedia?: InputMaybe<ComponentSharedMediaInput>;
  mainPhoto?: InputMaybe<Scalars['ID']['input']>;
  prizes?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  routeCard?: InputMaybe<Scalars['ID']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventInfoType>;
  winners?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerInput>>>;
};

export type EventInfoRelationResponseCollection = {
  __typename?: 'EventInfoRelationResponseCollection';
  data: Array<EventInfoEntity>;
};

export enum EventInfoType {
  GroupRide = 'GROUP_RIDE',
  Race = 'RACE'
}

export type FeaturedRouteCreator = {
  __typename?: 'FeaturedRouteCreator';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  routeCreators?: Maybe<Array<Maybe<ComponentSharedRouteCreator>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FeaturedRouteCreatorRouteCreatorsArgs = {
  filters?: InputMaybe<ComponentSharedRouteCreatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeaturedRouteCreatorEntity = {
  __typename?: 'FeaturedRouteCreatorEntity';
  attributes?: Maybe<FeaturedRouteCreator>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FeaturedRouteCreatorEntityResponse = {
  __typename?: 'FeaturedRouteCreatorEntityResponse';
  data?: Maybe<FeaturedRouteCreatorEntity>;
};

export type FeaturedRouteCreatorInput = {
  routeCreators?: InputMaybe<Array<InputMaybe<ComponentSharedRouteCreatorInput>>>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type Footer = {
  __typename?: 'Footer';
  bottomLinks: Array<Maybe<ComponentSharedLink>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groups: Array<Maybe<ComponentSharedLinksGroup>>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<FooterRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FooterBottomLinksArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FooterGroupsArgs = {
  filters?: InputMaybe<ComponentSharedLinksGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FooterLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type FooterEntity = {
  __typename?: 'FooterEntity';
  attributes?: Maybe<Footer>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FooterEntityResponse = {
  __typename?: 'FooterEntityResponse';
  data?: Maybe<FooterEntity>;
};

export type FooterInput = {
  bottomLinks?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>;
  groups?: InputMaybe<Array<InputMaybe<ComponentSharedLinksGroupInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FooterRelationResponseCollection = {
  __typename?: 'FooterRelationResponseCollection';
  data: Array<FooterEntity>;
};

export type GenericMorph = AccountPortalDynamicPage | Author | AvatarPart | BlogCategory | BlogPost | BlogTag | Branding | Challenge | ComponentSharedAuthors | ComponentSharedBlogPosts | ComponentSharedButton | ComponentSharedCancelPageSlide | ComponentSharedCard | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedContent | ComponentSharedContentCard | ComponentSharedContentLayers | ComponentSharedContentSwimlane | ComponentSharedContentTeaser | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHeader | ComponentSharedHeaderAcceptInvite | ComponentSharedHeaderVideo | ComponentSharedHighlights | ComponentSharedImage | ComponentSharedLink | ComponentSharedLinksCarousel | ComponentSharedLinksCarouselItem | ComponentSharedLinksGroup | ComponentSharedLogo | ComponentSharedLogoClouds | ComponentSharedMedia | ComponentSharedNavbar | ComponentSharedNavbarItem | ComponentSharedNavbarSettings | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedParagraph | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedQuestion | ComponentSharedRegisterCta | ComponentSharedRouteCreator | ComponentSharedRoutes | ComponentSharedRoutesSection | ComponentSharedRoutesSwimline | ComponentSharedSeo | ComponentSharedSideTextAndImage | ComponentSharedSimpleCard | ComponentSharedSimpleCardsWidget | ComponentSharedSimpleCta | ComponentSharedSocialPlatform | ComponentSharedSpotlight | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedStepCard | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTasksRulesCard | ComponentSharedTasksRulesWidget | ComponentSharedTestimonial | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedTwoColumnsContent | ComponentSharedVideo | ComponentSharedWorkouts | ComponentSharedWorkoutsSection | ComponentSharedWorkoutsSwimline | ComponentSharedYouTubeVideo | ComponentWinnablePrize | ComponentWinnableWinner | DynamicPage | EventInfo | FeaturedRouteCreator | Footer | GlobalChallenge | GlobalChallengeStage | Homepage | I18NLocale | LoadingScreen | LongTermChallenge | LongTermChallengeStage | Navbar | Partner | Post | Redirect | RouteCard | Spotlight | SpotlightDetail | StaticPage | SubscriptionCancelPage | SubscriptionCancelReason | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | VariablesConfig | WorkoutCard;

export type GlobalChallenge = {
  __typename?: 'GlobalChallenge';
  backgroundImage: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  globalChallengeId: Scalars['String']['output'];
  gradientStartColor?: Maybe<Scalars['String']['output']>;
  gradientStopColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<GlobalChallengeRelationResponseCollection>;
  logo: UploadFileEntityResponse;
  promoReward: ComponentWinnablePrize;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  realRewards?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  title: Scalars['String']['output'];
  trophyBadge: UploadFileEntityResponse;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  webLink?: Maybe<Scalars['String']['output']>;
};


export type GlobalChallengeLocalizationsArgs = {
  filters?: InputMaybe<GlobalChallengeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GlobalChallengeRealRewardsArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GlobalChallengeEntity = {
  __typename?: 'GlobalChallengeEntity';
  attributes?: Maybe<GlobalChallenge>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GlobalChallengeEntityResponse = {
  __typename?: 'GlobalChallengeEntityResponse';
  data?: Maybe<GlobalChallengeEntity>;
};

export type GlobalChallengeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GlobalChallengeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  globalChallengeId?: InputMaybe<StringFilterInput>;
  gradientStartColor?: InputMaybe<StringFilterInput>;
  gradientStopColor?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<GlobalChallengeFiltersInput>;
  not?: InputMaybe<GlobalChallengeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GlobalChallengeFiltersInput>>>;
  promoReward?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  realRewards?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  webLink?: InputMaybe<StringFilterInput>;
};

export type GlobalChallengeInput = {
  backgroundImage?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  globalChallengeId?: InputMaybe<Scalars['String']['input']>;
  gradientStartColor?: InputMaybe<Scalars['String']['input']>;
  gradientStopColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  promoReward?: InputMaybe<ComponentWinnablePrizeInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  realRewards?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  trophyBadge?: InputMaybe<Scalars['ID']['input']>;
  webLink?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalChallengeRelationResponseCollection = {
  __typename?: 'GlobalChallengeRelationResponseCollection';
  data: Array<GlobalChallengeEntity>;
};

export type GlobalChallengeStage = {
  __typename?: 'GlobalChallengeStage';
  badge: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  globalChallengeStageId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<GlobalChallengeStageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  realRewards?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type GlobalChallengeStageLocalizationsArgs = {
  filters?: InputMaybe<GlobalChallengeStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GlobalChallengeStageRealRewardsArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GlobalChallengeStageEntity = {
  __typename?: 'GlobalChallengeStageEntity';
  attributes?: Maybe<GlobalChallengeStage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GlobalChallengeStageEntityResponse = {
  __typename?: 'GlobalChallengeStageEntityResponse';
  data?: Maybe<GlobalChallengeStageEntity>;
};

export type GlobalChallengeStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GlobalChallengeStageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  globalChallengeStageId?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<GlobalChallengeStageFiltersInput>;
  not?: InputMaybe<GlobalChallengeStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GlobalChallengeStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  realRewards?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type GlobalChallengeStageInput = {
  badge?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  globalChallengeStageId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  realRewards?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalChallengeStageRelationResponseCollection = {
  __typename?: 'GlobalChallengeStageRelationResponseCollection';
  data: Array<GlobalChallengeStageEntity>;
};

export type Homepage = {
  __typename?: 'Homepage';
  SEO: ComponentSharedSeo;
  body?: Maybe<Array<Maybe<HomepageBodyDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<HomepageRelationResponseCollection>;
  navbarSettings?: Maybe<ComponentSharedNavbarSettings>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant: Scalars['String']['output'];
};


export type HomepageLocalizationsArgs = {
  filters?: InputMaybe<HomepageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HomepageBodyDynamicZone = ComponentSharedBlogPosts | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedContentTeaser | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHeader | ComponentSharedHeaderVideo | ComponentSharedHighlights | ComponentSharedLinksCarousel | ComponentSharedLogoClouds | ComponentSharedNavbar | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedRegisterCta | ComponentSharedRoutesSwimline | ComponentSharedSimpleCta | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedWorkoutsSwimline | ComponentSharedYouTubeVideo | Error;

export type HomepageEntity = {
  __typename?: 'HomepageEntity';
  attributes?: Maybe<Homepage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HomepageEntityResponse = {
  __typename?: 'HomepageEntityResponse';
  data?: Maybe<HomepageEntity>;
};

export type HomepageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<HomepageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<HomepageFiltersInput>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsFiltersInput>;
  not?: InputMaybe<HomepageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<HomepageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  variant?: InputMaybe<StringFilterInput>;
};

export type HomepageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  body?: InputMaybe<Array<Scalars['HomepageBodyDynamicZoneInput']['input']>>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageRelationResponseCollection = {
  __typename?: 'HomepageRelationResponseCollection';
  data: Array<HomepageEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LoadingScreen = {
  __typename?: 'LoadingScreen';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  image: UploadFileEntityResponse;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<LoadingScreenRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingType: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight: Scalars['Int']['output'];
};


export type LoadingScreenLocalizationsArgs = {
  filters?: InputMaybe<LoadingScreenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LoadingScreenEntity = {
  __typename?: 'LoadingScreenEntity';
  attributes?: Maybe<LoadingScreen>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LoadingScreenEntityResponse = {
  __typename?: 'LoadingScreenEntityResponse';
  data?: Maybe<LoadingScreenEntity>;
};

export type LoadingScreenEntityResponseCollection = {
  __typename?: 'LoadingScreenEntityResponseCollection';
  data: Array<LoadingScreenEntity>;
  meta: ResponseCollectionMeta;
};

export type LoadingScreenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LoadingScreenFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<LoadingScreenFiltersInput>;
  not?: InputMaybe<LoadingScreenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LoadingScreenFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  trainingType?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  weight?: InputMaybe<IntFilterInput>;
};

export type LoadingScreenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  trainingType?: InputMaybe<Scalars['JSON']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type LoadingScreenRelationResponseCollection = {
  __typename?: 'LoadingScreenRelationResponseCollection';
  data: Array<LoadingScreenEntity>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type LongTermChallenge = {
  __typename?: 'LongTermChallenge';
  completedStageBadge: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image: UploadFileEntityResponse;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<LongTermChallengeRelationResponseCollection>;
  longTermChallengeId: Scalars['String']['output'];
  longTermChallengeStages?: Maybe<LongTermChallengeStageRelationResponseCollection>;
  mapImage: UploadFileEntityResponse;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LongTermChallengeLocalizationsArgs = {
  filters?: InputMaybe<LongTermChallengeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LongTermChallengeLongTermChallengeStagesArgs = {
  filters?: InputMaybe<LongTermChallengeStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LongTermChallengeEntity = {
  __typename?: 'LongTermChallengeEntity';
  attributes?: Maybe<LongTermChallenge>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LongTermChallengeEntityResponse = {
  __typename?: 'LongTermChallengeEntityResponse';
  data?: Maybe<LongTermChallengeEntity>;
};

export type LongTermChallengeEntityResponseCollection = {
  __typename?: 'LongTermChallengeEntityResponseCollection';
  data: Array<LongTermChallengeEntity>;
  meta: ResponseCollectionMeta;
};

export type LongTermChallengeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LongTermChallengeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<LongTermChallengeFiltersInput>;
  longTermChallengeId?: InputMaybe<StringFilterInput>;
  longTermChallengeStages?: InputMaybe<LongTermChallengeStageFiltersInput>;
  not?: InputMaybe<LongTermChallengeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LongTermChallengeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LongTermChallengeInput = {
  completedStageBadge?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  longTermChallengeId?: InputMaybe<Scalars['String']['input']>;
  longTermChallengeStages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mapImage?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LongTermChallengeRelationResponseCollection = {
  __typename?: 'LongTermChallengeRelationResponseCollection';
  data: Array<LongTermChallengeEntity>;
};

export type LongTermChallengeStage = {
  __typename?: 'LongTermChallengeStage';
  badge: UploadFileEntityResponse;
  completedBadge?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relativeBadgePositionX: Scalars['Float']['output'];
  relativeBadgePositionY: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LongTermChallengeStageEntity = {
  __typename?: 'LongTermChallengeStageEntity';
  attributes?: Maybe<LongTermChallengeStage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LongTermChallengeStageEntityResponse = {
  __typename?: 'LongTermChallengeStageEntityResponse';
  data?: Maybe<LongTermChallengeStageEntity>;
};

export type LongTermChallengeStageEntityResponseCollection = {
  __typename?: 'LongTermChallengeStageEntityResponseCollection';
  data: Array<LongTermChallengeStageEntity>;
  meta: ResponseCollectionMeta;
};

export type LongTermChallengeStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LongTermChallengeStageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<LongTermChallengeStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LongTermChallengeStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  relativeBadgePositionX?: InputMaybe<FloatFilterInput>;
  relativeBadgePositionY?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LongTermChallengeStageInput = {
  badge?: InputMaybe<Scalars['ID']['input']>;
  completedBadge?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relativeBadgePositionX?: InputMaybe<Scalars['Float']['input']>;
  relativeBadgePositionY?: InputMaybe<Scalars['Float']['input']>;
};

export type LongTermChallengeStageRelationResponseCollection = {
  __typename?: 'LongTermChallengeStageRelationResponseCollection';
  data: Array<LongTermChallengeStageEntity>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAccountPortalDynamicPageLocalization?: Maybe<AccountPortalDynamicPageEntityResponse>;
  createAuthorLocalization?: Maybe<AuthorEntityResponse>;
  createAvatarPartLocalization?: Maybe<AvatarPartEntityResponse>;
  createBlogCategoryLocalization?: Maybe<BlogCategoryEntityResponse>;
  createBlogPostLocalization?: Maybe<BlogPostEntityResponse>;
  createBlogTagLocalization?: Maybe<BlogTagEntityResponse>;
  createBranding?: Maybe<BrandingEntityResponse>;
  createChallengeLocalization?: Maybe<ChallengeEntityResponse>;
  createDynamicPageLocalization?: Maybe<DynamicPageEntityResponse>;
  createEventInfoLocalization?: Maybe<EventInfoEntityResponse>;
  createFooterLocalization?: Maybe<FooterEntityResponse>;
  createGlobalChallengeLocalization?: Maybe<GlobalChallengeEntityResponse>;
  createGlobalChallengeStageLocalization?: Maybe<GlobalChallengeStageEntityResponse>;
  createHomepageLocalization?: Maybe<HomepageEntityResponse>;
  createLoadingScreen?: Maybe<LoadingScreenEntityResponse>;
  createLoadingScreenLocalization?: Maybe<LoadingScreenEntityResponse>;
  createLongTermChallenge?: Maybe<LongTermChallengeEntityResponse>;
  createLongTermChallengeLocalization?: Maybe<LongTermChallengeEntityResponse>;
  createLongTermChallengeStage?: Maybe<LongTermChallengeStageEntityResponse>;
  createNavbarLocalization?: Maybe<NavbarEntityResponse>;
  createPartnerLocalization?: Maybe<PartnerEntityResponse>;
  createPostLocalization?: Maybe<PostEntityResponse>;
  createRouteCard?: Maybe<RouteCardEntityResponse>;
  createSpotlightDetail?: Maybe<SpotlightDetailEntityResponse>;
  createSpotlightDetailLocalization?: Maybe<SpotlightDetailEntityResponse>;
  createSpotlightLocalization?: Maybe<SpotlightEntityResponse>;
  createStaticPageLocalization?: Maybe<StaticPageEntityResponse>;
  createSubscriptionCancelPageLocalization?: Maybe<SubscriptionCancelPageEntityResponse>;
  createSubscriptionCancelReasonLocalization?: Maybe<SubscriptionCancelReasonEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createVariablesConfig?: Maybe<VariablesConfigEntityResponse>;
  createWorkoutCard?: Maybe<WorkoutCardEntityResponse>;
  deleteBranding?: Maybe<BrandingEntityResponse>;
  deleteFeaturedRouteCreator?: Maybe<FeaturedRouteCreatorEntityResponse>;
  deleteLoadingScreen?: Maybe<LoadingScreenEntityResponse>;
  deleteLongTermChallenge?: Maybe<LongTermChallengeEntityResponse>;
  deleteLongTermChallengeStage?: Maybe<LongTermChallengeStageEntityResponse>;
  deleteRouteCard?: Maybe<RouteCardEntityResponse>;
  deleteSpotlightDetail?: Maybe<SpotlightDetailEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteVariablesConfig?: Maybe<VariablesConfigEntityResponse>;
  deleteWorkoutCard?: Maybe<WorkoutCardEntityResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateBranding?: Maybe<BrandingEntityResponse>;
  updateFeaturedRouteCreator?: Maybe<FeaturedRouteCreatorEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateLoadingScreen?: Maybe<LoadingScreenEntityResponse>;
  updateLongTermChallenge?: Maybe<LongTermChallengeEntityResponse>;
  updateLongTermChallengeStage?: Maybe<LongTermChallengeStageEntityResponse>;
  updateRouteCard?: Maybe<RouteCardEntityResponse>;
  updateSpotlightDetail?: Maybe<SpotlightDetailEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateVariablesConfig?: Maybe<VariablesConfigEntityResponse>;
  updateWorkoutCard?: Maybe<WorkoutCardEntityResponse>;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAccountPortalDynamicPageLocalizationArgs = {
  data?: InputMaybe<AccountPortalDynamicPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateAuthorLocalizationArgs = {
  data?: InputMaybe<AuthorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateAvatarPartLocalizationArgs = {
  data?: InputMaybe<AvatarPartInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogCategoryLocalizationArgs = {
  data?: InputMaybe<BlogCategoryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogPostLocalizationArgs = {
  data?: InputMaybe<BlogPostInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogTagLocalizationArgs = {
  data?: InputMaybe<BlogTagInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBrandingArgs = {
  data: BrandingInput;
};


export type MutationCreateChallengeLocalizationArgs = {
  data?: InputMaybe<ChallengeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateDynamicPageLocalizationArgs = {
  data?: InputMaybe<DynamicPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEventInfoLocalizationArgs = {
  data?: InputMaybe<EventInfoInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateFooterLocalizationArgs = {
  data?: InputMaybe<FooterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateGlobalChallengeLocalizationArgs = {
  data?: InputMaybe<GlobalChallengeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateGlobalChallengeStageLocalizationArgs = {
  data?: InputMaybe<GlobalChallengeStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateHomepageLocalizationArgs = {
  data?: InputMaybe<HomepageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLoadingScreenArgs = {
  data: LoadingScreenInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLoadingScreenLocalizationArgs = {
  data?: InputMaybe<LoadingScreenInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLongTermChallengeArgs = {
  data: LongTermChallengeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLongTermChallengeLocalizationArgs = {
  data?: InputMaybe<LongTermChallengeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLongTermChallengeStageArgs = {
  data: LongTermChallengeStageInput;
};


export type MutationCreateNavbarLocalizationArgs = {
  data?: InputMaybe<NavbarInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePartnerLocalizationArgs = {
  data?: InputMaybe<PartnerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePostLocalizationArgs = {
  data?: InputMaybe<PostInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateRouteCardArgs = {
  data: RouteCardInput;
};


export type MutationCreateSpotlightDetailArgs = {
  data: SpotlightDetailInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSpotlightDetailLocalizationArgs = {
  data?: InputMaybe<SpotlightDetailInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSpotlightLocalizationArgs = {
  data?: InputMaybe<SpotlightInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateStaticPageLocalizationArgs = {
  data?: InputMaybe<StaticPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSubscriptionCancelPageLocalizationArgs = {
  data?: InputMaybe<SubscriptionCancelPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSubscriptionCancelReasonLocalizationArgs = {
  data?: InputMaybe<SubscriptionCancelReasonInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateVariablesConfigArgs = {
  data: VariablesConfigInput;
};


export type MutationCreateWorkoutCardArgs = {
  data: WorkoutCardInput;
};


export type MutationDeleteBrandingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoadingScreenArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteLongTermChallengeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteLongTermChallengeStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRouteCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSpotlightDetailArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVariablesConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkoutCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateBrandingArgs = {
  data: BrandingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFeaturedRouteCreatorArgs = {
  data: FeaturedRouteCreatorInput;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateLoadingScreenArgs = {
  data: LoadingScreenInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateLongTermChallengeArgs = {
  data: LongTermChallengeInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateLongTermChallengeStageArgs = {
  data: LongTermChallengeStageInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateRouteCardArgs = {
  data: RouteCardInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSpotlightDetailArgs = {
  data: SpotlightDetailInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVariablesConfigArgs = {
  data: VariablesConfigInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWorkoutCardArgs = {
  data: WorkoutCardInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Navbar = {
  __typename?: 'Navbar';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NavbarRelationResponseCollection>;
  navbarSettings: ComponentSharedNavbarSettings;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NavbarLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type NavbarEntity = {
  __typename?: 'NavbarEntity';
  attributes?: Maybe<Navbar>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NavbarEntityResponse = {
  __typename?: 'NavbarEntityResponse';
  data?: Maybe<NavbarEntity>;
};

export type NavbarInput = {
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavbarRelationResponseCollection = {
  __typename?: 'NavbarRelationResponseCollection';
  data: Array<NavbarEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Partner = {
  __typename?: 'Partner';
  SEO?: Maybe<ComponentSharedSeo>;
  about?: Maybe<Scalars['String']['output']>;
  carousels?: Maybe<Array<Maybe<ComponentSharedSimpleCardsWidget>>>;
  contents?: Maybe<Array<Maybe<ComponentSharedTextWidget>>>;
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lead?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PartnerRelationResponseCollection>;
  logo: UploadFileEntityResponse;
  mainMedia?: Maybe<ComponentSharedMedia>;
  partnerId: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  thumbnailImage?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  web?: Maybe<Scalars['String']['output']>;
};


export type PartnerCarouselsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartnerContentsArgs = {
  filters?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartnerLocalizationsArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerEntity = {
  __typename?: 'PartnerEntity';
  attributes?: Maybe<Partner>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PartnerEntityResponse = {
  __typename?: 'PartnerEntityResponse';
  data?: Maybe<PartnerEntity>;
};

export type PartnerFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  about?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  carousels?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  contents?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  countryIsoCode?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  featured?: InputMaybe<BooleanFilterInput>;
  headline?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  lead?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PartnerFiltersInput>;
  mainMedia?: InputMaybe<ComponentSharedMediaFiltersInput>;
  not?: InputMaybe<PartnerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  partnerId?: InputMaybe<IntFilterInput>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  web?: InputMaybe<StringFilterInput>;
};

export type PartnerInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  carousels?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetInput>>>;
  contents?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetInput>>>;
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  mainMedia?: InputMaybe<ComponentSharedMediaInput>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRelationResponseCollection = {
  __typename?: 'PartnerRelationResponseCollection';
  data: Array<PartnerEntity>;
};

export type Post = {
  __typename?: 'Post';
  SEO?: Maybe<ComponentSharedSeo>;
  background?: Maybe<UploadFileEntityResponse>;
  category?: Maybe<Enum_Post_Category>;
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  localazy?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PostRelationResponseCollection>;
  paragraphs?: Maybe<Array<Maybe<ComponentSharedParagraph>>>;
  perex: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PostLocalizationsArgs = {
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostParagraphsArgs = {
  filters?: InputMaybe<ComponentSharedParagraphFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostEntity = {
  __typename?: 'PostEntity';
  attributes?: Maybe<Post>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PostEntityResponse = {
  __typename?: 'PostEntityResponse';
  data?: Maybe<PostEntity>;
};

export type PostFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  localazy?: InputMaybe<BooleanFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PostFiltersInput>;
  not?: InputMaybe<PostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  paragraphs?: InputMaybe<ComponentSharedParagraphFiltersInput>;
  perex?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  background?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Enum_Post_Category>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  localazy?: InputMaybe<Scalars['Boolean']['input']>;
  paragraphs?: InputMaybe<Array<InputMaybe<ComponentSharedParagraphInput>>>;
  perex?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostRelationResponseCollection = {
  __typename?: 'PostRelationResponseCollection';
  data: Array<PostEntity>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  _cmsAvatarPartById?: Maybe<AvatarPart>;
  _cmsChallenge?: Maybe<Challenge>;
  _cmsChallenges: Array<Challenge>;
  _cmsChallengesByIds: Array<Maybe<Challenge>>;
  _cmsEventInfo?: Maybe<EventInfo>;
  _cmsEventInfos: Array<EventInfo>;
  _cmsEventInfosByIds: Array<Maybe<EventInfo>>;
  _cmsGlobalChallengeById?: Maybe<GlobalChallenge>;
  _cmsGlobalChallengeStageById?: Maybe<GlobalChallengeStage>;
  _cmsPartner?: Maybe<Partner>;
  _cmsPartnersByIds: Array<Maybe<Partner>>;
  accountPortalDynamicPage: Array<AccountPortalDynamicPage>;
  accountPortalDynamicPageByPath?: Maybe<AccountPortalDynamicPage>;
  authorBySlug?: Maybe<Author>;
  authors: Array<Author>;
  blogCategories: Array<BlogCategory>;
  blogCategoryBySlug?: Maybe<BlogCategory>;
  blogPostBySlug?: Maybe<BlogPost>;
  blogPosts: Array<BlogPost>;
  blogPostsSearch: Array<BlogPost>;
  blogTagBySlug?: Maybe<BlogTag>;
  blogTags: Array<BlogTag>;
  branding?: Maybe<BrandingEntityResponse>;
  brandings?: Maybe<BrandingEntityResponseCollection>;
  challengeBySlug?: Maybe<Challenge>;
  dynamicPage: Array<DynamicPage>;
  dynamicPageByPath?: Maybe<DynamicPage>;
  featuredPartners: Array<Partner>;
  featuredRouteCreator?: Maybe<FeaturedRouteCreatorEntityResponse>;
  filterEventInfos: Array<Maybe<EventInfo>>;
  footer?: Maybe<Footer>;
  homepage?: Maybe<Homepage>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  latestSpotlight?: Maybe<Spotlight>;
  loadingScreen?: Maybe<LoadingScreenEntityResponse>;
  loadingScreens?: Maybe<LoadingScreenEntityResponseCollection>;
  longTermChallenge?: Maybe<LongTermChallengeEntityResponse>;
  longTermChallengeStage?: Maybe<LongTermChallengeStageEntityResponse>;
  longTermChallengeStages?: Maybe<LongTermChallengeStageEntityResponseCollection>;
  longTermChallenges?: Maybe<LongTermChallengeEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  navbar?: Maybe<Navbar>;
  partnerBySlug?: Maybe<Partner>;
  partners: Array<Partner>;
  postBySlug?: Maybe<Post>;
  posts: Array<Post>;
  redirect?: Maybe<Redirect>;
  redirects: Array<Redirect>;
  routeCard?: Maybe<RouteCardEntityResponse>;
  routeCards?: Maybe<RouteCardEntityResponseCollection>;
  spotlightBySlug?: Maybe<Spotlight>;
  spotlightDetail?: Maybe<SpotlightDetailEntityResponse>;
  spotlightDetails?: Maybe<SpotlightDetailEntityResponseCollection>;
  spotlights: Array<Spotlight>;
  staticPage?: Maybe<StaticPage>;
  subscriptionCancelPageBySlug?: Maybe<SubscriptionCancelPage>;
  subscriptionCancelReasons: Array<SubscriptionCancelReason>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  variablesConfig?: Maybe<VariablesConfigEntityResponse>;
  variablesConfigs?: Maybe<VariablesConfigEntityResponseCollection>;
  workoutCard?: Maybe<WorkoutCardEntityResponse>;
  workoutCards?: Maybe<WorkoutCardEntityResponseCollection>;
};


export type Query_CmsAvatarPartByIdArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  partId: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsChallengeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type Query_CmsChallengesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type Query_CmsChallengesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type Query_CmsEventInfoArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type Query_CmsEventInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type Query_CmsEventInfosByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsGlobalChallengeByIdArgs = {
  globalChallengeId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsGlobalChallengeStageByIdArgs = {
  globalChallengeStageId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsPartnerArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type Query_CmsPartnersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountPortalDynamicPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryAccountPortalDynamicPageByPathArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  path: Scalars['String']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryAuthorBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryAuthorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogCategoryBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryBlogPostBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryBlogPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogPostsSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogTagBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryBlogTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBrandingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandingsArgs = {
  filters?: InputMaybe<BrandingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryChallengeBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryDynamicPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryDynamicPageByPathArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  path: Scalars['String']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFeaturedPartnersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterEventInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFooterArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  variant: Scalars['String']['input'];
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLatestSpotlightArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryLoadingScreenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryLoadingScreensArgs = {
  filters?: InputMaybe<LoadingScreenFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLongTermChallengeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryLongTermChallengeStageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLongTermChallengeStagesArgs = {
  filters?: InputMaybe<LongTermChallengeStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLongTermChallengesArgs = {
  filters?: InputMaybe<LongTermChallengeFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNavbarArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryPartnerBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryPartnersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryPostBySlugArgs = {
  category?: InputMaybe<Enum_Post_Category>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRedirectArgs = {
  publicationState?: InputMaybe<PublicationState>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRedirectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRouteCardArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRouteCardsArgs = {
  filters?: InputMaybe<RouteCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySpotlightBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QuerySpotlightDetailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QuerySpotlightDetailsArgs = {
  filters?: InputMaybe<SpotlightDetailFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySpotlightsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryStaticPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QuerySubscriptionCancelPageBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QuerySubscriptionCancelReasonsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryVariablesConfigArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVariablesConfigsArgs = {
  filters?: InputMaybe<VariablesConfigFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryWorkoutCardArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkoutCardsArgs = {
  filters?: InputMaybe<WorkoutCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Redirect = {
  __typename?: 'Redirect';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  destination: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permanent: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type RouteCard = {
  __typename?: 'RouteCard';
  ascendedMeters?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distanceMeters?: Maybe<Scalars['Long']['output']>;
  estimatedTimeSeconds?: Maybe<Scalars['Long']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  routeId: Scalars['Long']['output'];
  simplifiedGeometryPoints?: Maybe<Scalars['JSON']['output']>;
  stravaSegmentsCount?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RouteCardEntity = {
  __typename?: 'RouteCardEntity';
  attributes?: Maybe<RouteCard>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type RouteCardEntityResponse = {
  __typename?: 'RouteCardEntityResponse';
  data?: Maybe<RouteCardEntity>;
};

export type RouteCardEntityResponseCollection = {
  __typename?: 'RouteCardEntityResponseCollection';
  data: Array<RouteCardEntity>;
  meta: ResponseCollectionMeta;
};

export type RouteCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RouteCardFiltersInput>>>;
  ascendedMeters?: InputMaybe<LongFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  distanceMeters?: InputMaybe<LongFilterInput>;
  estimatedTimeSeconds?: InputMaybe<LongFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RouteCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RouteCardFiltersInput>>>;
  rating?: InputMaybe<FloatFilterInput>;
  routeId?: InputMaybe<LongFilterInput>;
  simplifiedGeometryPoints?: InputMaybe<JsonFilterInput>;
  stravaSegmentsCount?: InputMaybe<IntFilterInput>;
  syncedAt?: InputMaybe<DateTimeFilterInput>;
  thumbnailUrl?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RouteCardInput = {
  ascendedMeters?: InputMaybe<Scalars['Long']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distanceMeters?: InputMaybe<Scalars['Long']['input']>;
  estimatedTimeSeconds?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  routeId?: InputMaybe<Scalars['Long']['input']>;
  simplifiedGeometryPoints?: InputMaybe<Scalars['JSON']['input']>;
  stravaSegmentsCount?: InputMaybe<Scalars['Int']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RouteCardRelationResponseCollection = {
  __typename?: 'RouteCardRelationResponseCollection';
  data: Array<RouteCardEntity>;
};

export type Spotlight = {
  __typename?: 'Spotlight';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  button?: Maybe<ComponentSharedButton>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latest?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SpotlightRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  spotlights?: Maybe<Array<Maybe<ComponentSharedSpotlight>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SpotlightLocalizationsArgs = {
  filters?: InputMaybe<SpotlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SpotlightSpotlightsArgs = {
  filters?: InputMaybe<ComponentSharedSpotlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SpotlightDetail = {
  __typename?: 'SpotlightDetail';
  blogPosts?: Maybe<ComponentSharedBlogPosts>;
  coverImage?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Date']['output'];
  featuredContent?: Maybe<Array<Maybe<ComponentSharedContentCard>>>;
  latest?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SpotlightDetailRelationResponseCollection>;
  previewImage?: Maybe<UploadFileEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  spotlightContent?: Maybe<Array<Maybe<SpotlightDetailSpotlightContentDynamicZone>>>;
  startDate: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  youtubeVideo?: Maybe<ComponentSharedYouTubeVideo>;
};


export type SpotlightDetailFeaturedContentArgs = {
  filters?: InputMaybe<ComponentSharedContentCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SpotlightDetailLocalizationsArgs = {
  filters?: InputMaybe<SpotlightDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SpotlightDetailEntity = {
  __typename?: 'SpotlightDetailEntity';
  attributes?: Maybe<SpotlightDetail>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SpotlightDetailEntityResponse = {
  __typename?: 'SpotlightDetailEntityResponse';
  data?: Maybe<SpotlightDetailEntity>;
};

export type SpotlightDetailEntityResponseCollection = {
  __typename?: 'SpotlightDetailEntityResponseCollection';
  data: Array<SpotlightDetailEntity>;
  meta: ResponseCollectionMeta;
};

export type SpotlightDetailFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SpotlightDetailFiltersInput>>>;
  blogPosts?: InputMaybe<ComponentSharedBlogPostsFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  featuredContent?: InputMaybe<ComponentSharedContentCardFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  latest?: InputMaybe<BooleanFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SpotlightDetailFiltersInput>;
  not?: InputMaybe<SpotlightDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SpotlightDetailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  startDate?: InputMaybe<DateFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  youtubeVideo?: InputMaybe<ComponentSharedYouTubeVideoFiltersInput>;
};

export type SpotlightDetailInput = {
  blogPosts?: InputMaybe<ComponentSharedBlogPostsInput>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  featuredContent?: InputMaybe<Array<InputMaybe<ComponentSharedContentCardInput>>>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  previewImage?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spotlightContent?: InputMaybe<Array<Scalars['SpotlightDetailSpotlightContentDynamicZoneInput']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youtubeVideo?: InputMaybe<ComponentSharedYouTubeVideoInput>;
};

export type SpotlightDetailRelationResponseCollection = {
  __typename?: 'SpotlightDetailRelationResponseCollection';
  data: Array<SpotlightDetailEntity>;
};

export type SpotlightDetailSpotlightContentDynamicZone = ComponentSharedContentSwimlane | ComponentSharedHighlights | ComponentSharedLinksCarousel | Error;

export type SpotlightEntity = {
  __typename?: 'SpotlightEntity';
  attributes?: Maybe<Spotlight>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SpotlightEntityResponse = {
  __typename?: 'SpotlightEntityResponse';
  data?: Maybe<SpotlightEntity>;
};

export type SpotlightFiltersInput = {
  anchorId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SpotlightFiltersInput>>>;
  button?: InputMaybe<ComponentSharedButtonFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  latest?: InputMaybe<BooleanFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SpotlightFiltersInput>;
  not?: InputMaybe<SpotlightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SpotlightFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  spotlights?: InputMaybe<ComponentSharedSpotlightFiltersInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SpotlightInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<Scalars['ID']['input']>;
  button?: InputMaybe<ComponentSharedButtonInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spotlights?: InputMaybe<Array<InputMaybe<ComponentSharedSpotlightInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpotlightRelationResponseCollection = {
  __typename?: 'SpotlightRelationResponseCollection';
  data: Array<SpotlightEntity>;
};

export type StaticPage = {
  __typename?: 'StaticPage';
  SEO?: Maybe<ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StaticPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type StaticPageLocalizationsArgs = {
  filters?: InputMaybe<StaticPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StaticPageEntity = {
  __typename?: 'StaticPageEntity';
  attributes?: Maybe<StaticPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StaticPageEntityResponse = {
  __typename?: 'StaticPageEntityResponse';
  data?: Maybe<StaticPageEntity>;
};

export type StaticPageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<StaticPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<StaticPageFiltersInput>;
  not?: InputMaybe<StaticPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StaticPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type StaticPageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StaticPageRelationResponseCollection = {
  __typename?: 'StaticPageRelationResponseCollection';
  data: Array<StaticPageEntity>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCancelPage = {
  __typename?: 'SubscriptionCancelPage';
  SEO?: Maybe<ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SubscriptionCancelPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slides?: Maybe<Array<Maybe<ComponentSharedCancelPageSlide>>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SubscriptionCancelPageLocalizationsArgs = {
  filters?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubscriptionCancelPageSlidesArgs = {
  filters?: InputMaybe<ComponentSharedCancelPageSlideFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionCancelPageEntity = {
  __typename?: 'SubscriptionCancelPageEntity';
  attributes?: Maybe<SubscriptionCancelPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionCancelPageEntityResponse = {
  __typename?: 'SubscriptionCancelPageEntityResponse';
  data?: Maybe<SubscriptionCancelPageEntity>;
};

export type SubscriptionCancelPageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<SubscriptionCancelPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  not?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriptionCancelPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slides?: InputMaybe<ComponentSharedCancelPageSlideFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriptionCancelPageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slides?: InputMaybe<Array<InputMaybe<ComponentSharedCancelPageSlideInput>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCancelPageRelationResponseCollection = {
  __typename?: 'SubscriptionCancelPageRelationResponseCollection';
  data: Array<SubscriptionCancelPageEntity>;
};

export type SubscriptionCancelReason = {
  __typename?: 'SubscriptionCancelReason';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SubscriptionCancelReasonRelationResponseCollection>;
  position: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showNote: Scalars['Boolean']['output'];
  subscriptionCancelPage?: Maybe<SubscriptionCancelPageEntityResponse>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SubscriptionCancelReasonLocalizationsArgs = {
  filters?: InputMaybe<SubscriptionCancelReasonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionCancelReasonEntity = {
  __typename?: 'SubscriptionCancelReasonEntity';
  attributes?: Maybe<SubscriptionCancelReason>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionCancelReasonEntityResponse = {
  __typename?: 'SubscriptionCancelReasonEntityResponse';
  data?: Maybe<SubscriptionCancelReasonEntity>;
};

export type SubscriptionCancelReasonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubscriptionCancelReasonFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SubscriptionCancelReasonFiltersInput>;
  not?: InputMaybe<SubscriptionCancelReasonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriptionCancelReasonFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  showNote?: InputMaybe<BooleanFilterInput>;
  subscriptionCancelPage?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriptionCancelReasonInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showNote?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionCancelPage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCancelReasonRelationResponseCollection = {
  __typename?: 'SubscriptionCancelReasonRelationResponseCollection';
  data: Array<SubscriptionCancelReasonEntity>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type VariablesConfig = {
  __typename?: 'VariablesConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['String']['output'];
};

export type VariablesConfigEntity = {
  __typename?: 'VariablesConfigEntity';
  attributes?: Maybe<VariablesConfig>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type VariablesConfigEntityResponse = {
  __typename?: 'VariablesConfigEntityResponse';
  data?: Maybe<VariablesConfigEntity>;
};

export type VariablesConfigEntityResponseCollection = {
  __typename?: 'VariablesConfigEntityResponseCollection';
  data: Array<VariablesConfigEntity>;
  meta: ResponseCollectionMeta;
};

export type VariablesConfigFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<VariablesConfigFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<VariablesConfigFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<VariablesConfigFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type VariablesConfigInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkoutCard = {
  __typename?: 'WorkoutCard';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Long']['output']>;
  durationType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  segments?: Maybe<Scalars['JSON']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Scalars['JSON']['output']>;
  tss?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workoutId: Scalars['Long']['output'];
  workoutType?: Maybe<Scalars['String']['output']>;
};

export type WorkoutCardEntity = {
  __typename?: 'WorkoutCardEntity';
  attributes?: Maybe<WorkoutCard>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WorkoutCardEntityResponse = {
  __typename?: 'WorkoutCardEntityResponse';
  data?: Maybe<WorkoutCardEntity>;
};

export type WorkoutCardEntityResponseCollection = {
  __typename?: 'WorkoutCardEntityResponseCollection';
  data: Array<WorkoutCardEntity>;
  meta: ResponseCollectionMeta;
};

export type WorkoutCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<WorkoutCardFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  duration?: InputMaybe<LongFilterInput>;
  durationType?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<WorkoutCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WorkoutCardFiltersInput>>>;
  rating?: InputMaybe<FloatFilterInput>;
  segments?: InputMaybe<JsonFilterInput>;
  syncedAt?: InputMaybe<DateTimeFilterInput>;
  tags?: InputMaybe<JsonFilterInput>;
  tss?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workoutId?: InputMaybe<LongFilterInput>;
  workoutType?: InputMaybe<StringFilterInput>;
};

export type WorkoutCardInput = {
  duration?: InputMaybe<Scalars['Long']['input']>;
  durationType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  segments?: InputMaybe<Scalars['JSON']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  tss?: InputMaybe<Scalars['Int']['input']>;
  workoutId?: InputMaybe<Scalars['Long']['input']>;
  workoutType?: InputMaybe<Scalars['String']['input']>;
};

export type WorkoutCardRelationResponseCollection = {
  __typename?: 'WorkoutCardRelationResponseCollection';
  data: Array<WorkoutCardEntity>;
};

export type ButtonFragment = { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null };

export type ChallengeEntityResponseCollectionFragment = { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> };

export type ChallengeEntityResponseFragment = { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null } | null };

export type ChallengeEntityFragment = { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null };

export type ChallengesListItemFragment = { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null };

export type ContentLayersFragment = { __typename?: 'ComponentSharedContentLayers', aim: Enum_Componentsharedcontentlayers_Aim, perspective: Enum_Componentsharedcontentlayers_Perspective, segment: {}, contentType: Enum_Componentsharedcontentlayers_Contenttype };

type HomepageBody_ComponentSharedBlogPosts_Fragment = { __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

type HomepageBody_ComponentSharedChallenges_Fragment = { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> } | null };

type HomepageBody_ComponentSharedChecklist_Fragment = { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

type HomepageBody_ComponentSharedCompanionAppCta_Fragment = { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type HomepageBody_ComponentSharedContentTeaser_Fragment = { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type HomepageBody_ComponentSharedEvents_Fragment = { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type HomepageBody_ComponentSharedFaq_Fragment = { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedFeaturedLogo_Fragment = { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

type HomepageBody_ComponentSharedHeader_Fragment = { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type HomepageBody_ComponentSharedHeaderVideo_Fragment = { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null };

type HomepageBody_ComponentSharedHighlights_Fragment = { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

type HomepageBody_ComponentSharedLinksCarousel_Fragment = { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type HomepageBody_ComponentSharedLogoClouds_Fragment = { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

type HomepageBody_ComponentSharedNavbar_Fragment = { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

type HomepageBody_ComponentSharedNewsletterCta_Fragment = { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type HomepageBody_ComponentSharedPageNavigation_Fragment = { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type HomepageBody_ComponentSharedPlansSelector_Fragment = { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedPricing_Fragment = { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedPrizes_Fragment = { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedProductsComparison_Fragment = { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedRegisterCta_Fragment = { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type HomepageBody_ComponentSharedRoutesSwimline_Fragment = { __typename: 'ComponentSharedRoutesSwimline', id: string, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routes?: { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> } | null };

type HomepageBody_ComponentSharedSimpleCta_Fragment = { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

type HomepageBody_ComponentSharedSpotlights_Fragment = { __typename: 'ComponentSharedSpotlights' };

type HomepageBody_ComponentSharedSpotlightsList_Fragment = { __typename: 'ComponentSharedSpotlightsList' };

type HomepageBody_ComponentSharedSteps_Fragment = { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedStripe_Fragment = { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

type HomepageBody_ComponentSharedTestimonialsSection_Fragment = { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

type HomepageBody_ComponentSharedTextBlock_Fragment = { __typename: 'ComponentSharedTextBlock', id: string, text: string };

type HomepageBody_ComponentSharedWorkoutsSwimline_Fragment = { __typename: 'ComponentSharedWorkoutsSwimline', expand?: boolean | null, workoutsAnchor?: string | null, workoutsTitle?: string | null, workouts?: { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> } | null };

type HomepageBody_ComponentSharedYouTubeVideo_Fragment = { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type HomepageBody_Error_Fragment = { __typename: 'Error' };

export type HomepageBodyFragment = HomepageBody_ComponentSharedBlogPosts_Fragment | HomepageBody_ComponentSharedChallenges_Fragment | HomepageBody_ComponentSharedChecklist_Fragment | HomepageBody_ComponentSharedCompanionAppCta_Fragment | HomepageBody_ComponentSharedContentTeaser_Fragment | HomepageBody_ComponentSharedEvents_Fragment | HomepageBody_ComponentSharedFaq_Fragment | HomepageBody_ComponentSharedFeaturedLogo_Fragment | HomepageBody_ComponentSharedHeader_Fragment | HomepageBody_ComponentSharedHeaderVideo_Fragment | HomepageBody_ComponentSharedHighlights_Fragment | HomepageBody_ComponentSharedLinksCarousel_Fragment | HomepageBody_ComponentSharedLogoClouds_Fragment | HomepageBody_ComponentSharedNavbar_Fragment | HomepageBody_ComponentSharedNewsletterCta_Fragment | HomepageBody_ComponentSharedPageNavigation_Fragment | HomepageBody_ComponentSharedPlansSelector_Fragment | HomepageBody_ComponentSharedPricing_Fragment | HomepageBody_ComponentSharedPrizes_Fragment | HomepageBody_ComponentSharedProductsComparison_Fragment | HomepageBody_ComponentSharedRegisterCta_Fragment | HomepageBody_ComponentSharedRoutesSwimline_Fragment | HomepageBody_ComponentSharedSimpleCta_Fragment | HomepageBody_ComponentSharedSpotlights_Fragment | HomepageBody_ComponentSharedSpotlightsList_Fragment | HomepageBody_ComponentSharedSteps_Fragment | HomepageBody_ComponentSharedStripe_Fragment | HomepageBody_ComponentSharedTestimonialsSection_Fragment | HomepageBody_ComponentSharedTextBlock_Fragment | HomepageBody_ComponentSharedWorkoutsSwimline_Fragment | HomepageBody_ComponentSharedYouTubeVideo_Fragment | HomepageBody_Error_Fragment;

type DynamicPageBody_ComponentSharedAuthors_Fragment = { __typename: 'ComponentSharedAuthors', id: string, authorsType?: Enum_Componentsharedauthors_Type | null, authorsByType: Array<{ __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null> };

type DynamicPageBody_ComponentSharedBlogPosts_Fragment = { __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

type DynamicPageBody_ComponentSharedChallenges_Fragment = { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> } | null };

type DynamicPageBody_ComponentSharedChecklist_Fragment = { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

type DynamicPageBody_ComponentSharedCompanionAppCta_Fragment = { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type DynamicPageBody_ComponentSharedContentTeaser_Fragment = { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type DynamicPageBody_ComponentSharedEvents_Fragment = { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type DynamicPageBody_ComponentSharedFaq_Fragment = { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedFeaturedLogo_Fragment = { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

type DynamicPageBody_ComponentSharedHeader_Fragment = { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type DynamicPageBody_ComponentSharedHeaderAcceptInvite_Fragment = { __typename: 'ComponentSharedHeaderAcceptInvite', id: string, acceptInviteHeading: string, acceptInviteHeadingFallback?: string | null, acceptInviteSubheading: string, acceptInviteSubheadingFallback?: string | null, acceptInviteButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null }, acceptInviteButtonFallback?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, acceptInviteBackgroundImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

type DynamicPageBody_ComponentSharedHeaderVideo_Fragment = { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null };

type DynamicPageBody_ComponentSharedHighlights_Fragment = { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

type DynamicPageBody_ComponentSharedLinksCarousel_Fragment = { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type DynamicPageBody_ComponentSharedLogoClouds_Fragment = { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

type DynamicPageBody_ComponentSharedNavbar_Fragment = { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

type DynamicPageBody_ComponentSharedNewsletterCta_Fragment = { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type DynamicPageBody_ComponentSharedPageNavigation_Fragment = { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type DynamicPageBody_ComponentSharedPlansSelector_Fragment = { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedPricing_Fragment = { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedPrizes_Fragment = { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedProductsComparison_Fragment = { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedRegisterCta_Fragment = { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type DynamicPageBody_ComponentSharedRoutesSwimline_Fragment = { __typename: 'ComponentSharedRoutesSwimline', id: string, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routes?: { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> } | null };

type DynamicPageBody_ComponentSharedSimpleCta_Fragment = { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

type DynamicPageBody_ComponentSharedSpotlights_Fragment = { __typename: 'ComponentSharedSpotlights' };

type DynamicPageBody_ComponentSharedSpotlightsList_Fragment = { __typename: 'ComponentSharedSpotlightsList' };

type DynamicPageBody_ComponentSharedSteps_Fragment = { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedStripe_Fragment = { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

type DynamicPageBody_ComponentSharedTestimonialsSection_Fragment = { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

type DynamicPageBody_ComponentSharedTextBlock_Fragment = { __typename: 'ComponentSharedTextBlock', id: string, text: string };

type DynamicPageBody_ComponentSharedTwoColumnsContent_Fragment = { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

type DynamicPageBody_ComponentSharedWorkoutsSwimline_Fragment = { __typename: 'ComponentSharedWorkoutsSwimline', expand?: boolean | null, workoutsAnchor?: string | null, workoutsTitle?: string | null, workouts?: { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> } | null };

type DynamicPageBody_ComponentSharedYouTubeVideo_Fragment = { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type DynamicPageBody_Error_Fragment = { __typename: 'Error' };

export type DynamicPageBodyFragment = DynamicPageBody_ComponentSharedAuthors_Fragment | DynamicPageBody_ComponentSharedBlogPosts_Fragment | DynamicPageBody_ComponentSharedChallenges_Fragment | DynamicPageBody_ComponentSharedChecklist_Fragment | DynamicPageBody_ComponentSharedCompanionAppCta_Fragment | DynamicPageBody_ComponentSharedContentTeaser_Fragment | DynamicPageBody_ComponentSharedEvents_Fragment | DynamicPageBody_ComponentSharedFaq_Fragment | DynamicPageBody_ComponentSharedFeaturedLogo_Fragment | DynamicPageBody_ComponentSharedHeader_Fragment | DynamicPageBody_ComponentSharedHeaderAcceptInvite_Fragment | DynamicPageBody_ComponentSharedHeaderVideo_Fragment | DynamicPageBody_ComponentSharedHighlights_Fragment | DynamicPageBody_ComponentSharedLinksCarousel_Fragment | DynamicPageBody_ComponentSharedLogoClouds_Fragment | DynamicPageBody_ComponentSharedNavbar_Fragment | DynamicPageBody_ComponentSharedNewsletterCta_Fragment | DynamicPageBody_ComponentSharedPageNavigation_Fragment | DynamicPageBody_ComponentSharedPlansSelector_Fragment | DynamicPageBody_ComponentSharedPricing_Fragment | DynamicPageBody_ComponentSharedPrizes_Fragment | DynamicPageBody_ComponentSharedProductsComparison_Fragment | DynamicPageBody_ComponentSharedRegisterCta_Fragment | DynamicPageBody_ComponentSharedRoutesSwimline_Fragment | DynamicPageBody_ComponentSharedSimpleCta_Fragment | DynamicPageBody_ComponentSharedSpotlights_Fragment | DynamicPageBody_ComponentSharedSpotlightsList_Fragment | DynamicPageBody_ComponentSharedSteps_Fragment | DynamicPageBody_ComponentSharedStripe_Fragment | DynamicPageBody_ComponentSharedTestimonialsSection_Fragment | DynamicPageBody_ComponentSharedTextBlock_Fragment | DynamicPageBody_ComponentSharedTwoColumnsContent_Fragment | DynamicPageBody_ComponentSharedWorkoutsSwimline_Fragment | DynamicPageBody_ComponentSharedYouTubeVideo_Fragment | DynamicPageBody_Error_Fragment;

type BlogDynamicBody_ComponentSharedBlogPosts_Fragment = { __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

type BlogDynamicBody_ComponentSharedChallenges_Fragment = { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedChecklist_Fragment = { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

type BlogDynamicBody_ComponentSharedCompanionAppCta_Fragment = { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type BlogDynamicBody_ComponentSharedEvents_Fragment = { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedFaq_Fragment = { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedFeaturedLogo_Fragment = { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

type BlogDynamicBody_ComponentSharedHighlights_Fragment = { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

type BlogDynamicBody_ComponentSharedLinksCarousel_Fragment = { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type BlogDynamicBody_ComponentSharedLogoClouds_Fragment = { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

type BlogDynamicBody_ComponentSharedNavbar_Fragment = { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

type BlogDynamicBody_ComponentSharedNewsletterCta_Fragment = { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type BlogDynamicBody_ComponentSharedPageNavigation_Fragment = { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type BlogDynamicBody_ComponentSharedPlansSelector_Fragment = { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedPricing_Fragment = { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedPrizes_Fragment = { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedProductsComparison_Fragment = { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedRegisterCta_Fragment = { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type BlogDynamicBody_ComponentSharedRoutesSwimline_Fragment = { __typename: 'ComponentSharedRoutesSwimline', id: string, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routes?: { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedSimpleCta_Fragment = { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

type BlogDynamicBody_ComponentSharedSpotlights_Fragment = { __typename: 'ComponentSharedSpotlights' };

type BlogDynamicBody_ComponentSharedSpotlightsList_Fragment = { __typename: 'ComponentSharedSpotlightsList' };

type BlogDynamicBody_ComponentSharedSteps_Fragment = { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedStripe_Fragment = { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

type BlogDynamicBody_ComponentSharedTestimonialsSection_Fragment = { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

type BlogDynamicBody_ComponentSharedTextBlock_Fragment = { __typename: 'ComponentSharedTextBlock', id: string, text: string };

type BlogDynamicBody_ComponentSharedTwoColumnsContent_Fragment = { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

type BlogDynamicBody_ComponentSharedWorkoutsSwimline_Fragment = { __typename: 'ComponentSharedWorkoutsSwimline', expand?: boolean | null, workoutsAnchor?: string | null, workoutsTitle?: string | null, workouts?: { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedYouTubeVideo_Fragment = { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type BlogDynamicBody_Error_Fragment = { __typename: 'Error' };

export type BlogDynamicBodyFragment = BlogDynamicBody_ComponentSharedBlogPosts_Fragment | BlogDynamicBody_ComponentSharedChallenges_Fragment | BlogDynamicBody_ComponentSharedChecklist_Fragment | BlogDynamicBody_ComponentSharedCompanionAppCta_Fragment | BlogDynamicBody_ComponentSharedEvents_Fragment | BlogDynamicBody_ComponentSharedFaq_Fragment | BlogDynamicBody_ComponentSharedFeaturedLogo_Fragment | BlogDynamicBody_ComponentSharedHighlights_Fragment | BlogDynamicBody_ComponentSharedLinksCarousel_Fragment | BlogDynamicBody_ComponentSharedLogoClouds_Fragment | BlogDynamicBody_ComponentSharedNavbar_Fragment | BlogDynamicBody_ComponentSharedNewsletterCta_Fragment | BlogDynamicBody_ComponentSharedPageNavigation_Fragment | BlogDynamicBody_ComponentSharedPlansSelector_Fragment | BlogDynamicBody_ComponentSharedPricing_Fragment | BlogDynamicBody_ComponentSharedPrizes_Fragment | BlogDynamicBody_ComponentSharedProductsComparison_Fragment | BlogDynamicBody_ComponentSharedRegisterCta_Fragment | BlogDynamicBody_ComponentSharedRoutesSwimline_Fragment | BlogDynamicBody_ComponentSharedSimpleCta_Fragment | BlogDynamicBody_ComponentSharedSpotlights_Fragment | BlogDynamicBody_ComponentSharedSpotlightsList_Fragment | BlogDynamicBody_ComponentSharedSteps_Fragment | BlogDynamicBody_ComponentSharedStripe_Fragment | BlogDynamicBody_ComponentSharedTestimonialsSection_Fragment | BlogDynamicBody_ComponentSharedTextBlock_Fragment | BlogDynamicBody_ComponentSharedTwoColumnsContent_Fragment | BlogDynamicBody_ComponentSharedWorkoutsSwimline_Fragment | BlogDynamicBody_ComponentSharedYouTubeVideo_Fragment | BlogDynamicBody_Error_Fragment;

export type AuthorsByTypeFragment = { __typename?: 'ComponentSharedAuthors', id: string, authorsType?: Enum_Componentsharedauthors_Type | null, authorsByType: Array<{ __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null> };

export type BlogPostListItemFragment = { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

export type BlogPostsFragment = { __typename?: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

export type ChallengesFragment = { __typename?: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> } | null };

export type ChecklistFragment = { __typename?: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

export type CompanionAppCtaFragment = { __typename?: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

export type ContentTeaserFragment = { __typename?: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

export type EventsFragment = { __typename?: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

export type QuestionFragment = { __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null };

export type FaqFragment = { __typename?: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type FeaturedLogoFragment = { __typename?: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

export type HeaderAcceptInviteFragment = { __typename?: 'ComponentSharedHeaderAcceptInvite', id: string, acceptInviteHeading: string, acceptInviteHeadingFallback?: string | null, acceptInviteSubheading: string, acceptInviteSubheadingFallback?: string | null, acceptInviteButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null }, acceptInviteButtonFallback?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, acceptInviteBackgroundImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

export type VideoFragment = { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type HeaderVideoFragment = { __typename?: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null };

export type HeaderFragment = { __typename?: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

export type ContentCardFragment = { __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type HighlightsFragment = { __typename?: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

export type LinksCarouselFragment = { __typename?: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

export type LogoCloudsFragment = { __typename?: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

export type NavbarFragment = { __typename?: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

export type NewsletterCtaFragment = { __typename?: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type PageNavigationFragment = { __typename?: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

export type PlansSelectorFragment = { __typename?: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type PricingFragment = { __typename?: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type ChallengePrizeFragment = { __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type PrizesFragment = { __typename?: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type ProductsComparisonFragment = { __typename?: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type RegisterCtaFragment = { __typename?: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type RoutesSwimlineFragment = { __typename?: 'ComponentSharedRoutesSwimline', id: string, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routes?: { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> } | null };

export type SimpleCtaFragment = { __typename?: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

export type StepFragment = { __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

export type StepsFragment = { __typename?: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type StripeFragment = { __typename?: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

export type TestimonialFragment = { __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string };

export type TestimonialsSectionFragment = { __typename?: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

export type TextBlockFragment = { __typename?: 'ComponentSharedTextBlock', id: string, text: string };

export type TwoColumnsContentFragment = { __typename?: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

export type WorkoutsSwimlineFragment = { __typename?: 'ComponentSharedWorkoutsSwimline', expand?: boolean | null, workoutsAnchor?: string | null, workoutsTitle?: string | null, workouts?: { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> } | null };

export type YoutubeVideoFragment = { __typename?: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type EventInfoEntityFragment = { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null } | null };

export type EventInfoEntityRelationCollectionItemFragment = { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> };

export type EventInfoFragment = { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null };

export type LogoFragment = { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

export type NavbarSettingsFragment = { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type RouteCardRelationResponseCollectionFragment = { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> };

export type RouteCardEntityResponseFragment = { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null };

export type RouteCardEntityFragment = { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null };

export type RouteCardFragment = { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null };

export type SeoFragment = { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type UploadFileRelationResponseCollectionFragment = { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> };

export type UploadFileEntityResponseFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null };

export type UploadFileEntityFragment = { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null };

export type UploadFileFragment = { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null };

export type WorkoutCardRelationResponseCollectionFragment = { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> };

export type WorkoutCardEntityResponseFragment = { __typename?: 'WorkoutCardEntityResponse', data?: { __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null } | null };

export type WorkoutCardEntityFragment = { __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null };

export type WorkoutCardFragment = { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null };

export type AuthorFragment = { __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

export type AuthorBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type AuthorBySlugQuery = { __typename?: 'Query', authorBySlug?: { __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, localizations?: { __typename?: 'AuthorRelationResponseCollection', data: Array<{ __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', locale?: string | null } | null }> } | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null };

export type AuthorsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type AuthorsQuery = { __typename?: 'Query', authors: Array<{ __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null }> };

export type AuthorsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type AuthorsSitemapQuery = { __typename?: 'Query', authors: Array<{ __typename?: 'Author', slug: string, locale?: string | null, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null, localizations?: { __typename?: 'AuthorRelationResponseCollection', data: Array<{ __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', locale?: string | null, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null } | null }> } | null }> };

export type BlogCategoriesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogCategoriesQuery = { __typename?: 'Query', blogCategories: Array<{ __typename?: 'BlogCategory', id: string, title: string, slug: string, locale?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, localizations?: { __typename?: 'BlogCategoryRelationResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', locale?: string | null } | null }> } | null }> };

export type BlogCategoriesSitemapQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogCategoriesSitemapQuery = { __typename?: 'Query', blogCategories: Array<{ __typename?: 'BlogCategory', slug: string, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'BlogCategoryRelationResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', updatedAt?: string | null, locale?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type BlogPostsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsQuery = { __typename?: 'Query', blogPosts: Array<{ __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, publishDate: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, slug: string, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null } | null } | null }> };

export type BlogPostsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsSitemapQuery = { __typename?: 'Query', blogPosts: Array<{ __typename?: 'BlogPost', slug: string, locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type BlogPostsSearchQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsSearchQuery = { __typename?: 'Query', blogPostsSearch: Array<{ __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, publishDate: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, slug: string, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null } | null } | null }> };

export type BlogPostsListItemFragment = { __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, publishDate: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, slug: string, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null } | null } | null };

export type BlogPostsBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsBySlugQuery = { __typename?: 'Query', blogPostBySlug?: { __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, body?: string | null, publishDate: string, structuredDataHeadline?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', id?: string | null, attributes?: { __typename?: 'Author', name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string, slug: string, locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } } | null } | null } | null, dynamicBody?: Array<{ __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null } | { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> } | null } | { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string } | { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } } | { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null } | { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> } | { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null } | { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedRoutesSwimline', id: string, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routes?: { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> } | null } | { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } } | { __typename: 'ComponentSharedSpotlights' } | { __typename: 'ComponentSharedSpotlightsList' } | { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null } | { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> } | { __typename: 'ComponentSharedTextBlock', id: string, text: string } | { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | { __typename: 'ComponentSharedWorkoutsSwimline', expand?: boolean | null, workoutsAnchor?: string | null, workoutsTitle?: string | null, workouts?: { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> } | null } | { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'Error' } | null> | null, contentLayers?: { __typename?: 'ComponentSharedContentLayers', aim: Enum_Componentsharedcontentlayers_Aim, perspective: Enum_Componentsharedcontentlayers_Perspective, segment: {}, contentType: Enum_Componentsharedcontentlayers_Contenttype } | null, localizations?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', locale?: string | null } | null }> } | null } | null };

export type BlogTagBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BlogTagBySlugQuery = { __typename?: 'Query', blogTagBySlug?: { __typename?: 'BlogTag', id: string, title: string, slug: string, locale?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, localizations?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', attributes?: { __typename?: 'BlogTag', locale?: string | null } | null }> } | null } | null };

export type BlogTagsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type BlogTagsQuery = { __typename?: 'Query', blogTags: Array<{ __typename?: 'BlogTag', id: string, title: string, slug: string, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } }> };

export type BlogTagsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type BlogTagsSitemapQuery = { __typename?: 'Query', blogTags: Array<{ __typename?: 'BlogTag', slug: string, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', attributes?: { __typename?: 'BlogTag', locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type DynamicPageQueryVariables = Exact<{
  path: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type DynamicPageQuery = { __typename?: 'Query', dynamicPageByPath?: { __typename?: 'DynamicPage', title: string, structuredDataHeadline?: string | null, publishedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, navbarSettings?: { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, body?: Array<{ __typename: 'ComponentSharedAuthors', id: string, authorsType?: Enum_Componentsharedauthors_Type | null, authorsByType: Array<{ __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null> } | { __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null } | { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> } | null } | { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string } | { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } } | { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedHeaderAcceptInvite', id: string, acceptInviteHeading: string, acceptInviteHeadingFallback?: string | null, acceptInviteSubheading: string, acceptInviteSubheadingFallback?: string | null, acceptInviteButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null }, acceptInviteButtonFallback?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, acceptInviteBackgroundImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null } | { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null } | { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> } | { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null } | { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedRoutesSwimline', id: string, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routes?: { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> } | null } | { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } } | { __typename: 'ComponentSharedSpotlights' } | { __typename: 'ComponentSharedSpotlightsList' } | { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null } | { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> } | { __typename: 'ComponentSharedTextBlock', id: string, text: string } | { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | { __typename: 'ComponentSharedWorkoutsSwimline', expand?: boolean | null, workoutsAnchor?: string | null, workoutsTitle?: string | null, workouts?: { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> } | null } | { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'Error' } | null> | null, contentLayers?: { __typename?: 'ComponentSharedContentLayers', aim: Enum_Componentsharedcontentlayers_Aim, perspective: Enum_Componentsharedcontentlayers_Perspective, segment: {}, contentType: Enum_Componentsharedcontentlayers_Contenttype } | null, localizations?: { __typename?: 'DynamicPageRelationResponseCollection', data: Array<{ __typename?: 'DynamicPageEntity', attributes?: { __typename?: 'DynamicPage', locale?: string | null } | null }> } | null } | null };

export type DynamicPagesSitemapQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type DynamicPagesSitemapQuery = { __typename?: 'Query', dynamicPage: Array<{ __typename?: 'DynamicPage', path: string, locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'DynamicPageRelationResponseCollection', data: Array<{ __typename?: 'DynamicPageEntity', attributes?: { __typename?: 'DynamicPage', locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type FooterLinkGroupsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type FooterLinkGroupsQuery = { __typename?: 'Query', footer?: { __typename?: 'Footer', groups: Array<{ __typename?: 'ComponentSharedLinksGroup', title: string, links: Array<{ __typename?: 'ComponentSharedLink', title: string, url: string } | null> } | null>, bottomLinks: Array<{ __typename?: 'ComponentSharedLink', title: string, url: string } | null> } | null };

export type HomepageQueryVariables = Exact<{
  variant: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type HomepageQuery = { __typename?: 'Query', homepage?: { __typename?: 'Homepage', SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, navbarSettings?: { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, body?: Array<{ __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null } | { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, badgeToReward?: {} | null, availableFrom?: string | null, availableTo?: string | null, expandTitle?: string | null } | null }> } | null } | { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string } | { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, category?: string | null, locale?: string | null, longDescription?: string | null, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, defaultSessionStartDateTimeUtc?: string | null, defaultSessionId?: string | null, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, routeCard?: { __typename?: 'RouteCardEntityResponse', data?: { __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null } | null } | null } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } } | { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null } | { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null } | { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> } | { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null } | { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedRoutesSwimline', id: string, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routes?: { __typename?: 'RouteCardRelationResponseCollection', data: Array<{ __typename?: 'RouteCardEntity', id?: string | null, attributes?: { __typename?: 'RouteCard', ascendedMeters?: any | null, distanceMeters?: any | null, estimatedTimeSeconds?: any | null, name?: string | null, rating?: number | null, routeId: any, simplifiedGeometryPoints?: {} | null, stravaSegmentsCount?: number | null, thumbnailUrl?: string | null, description?: string | null } | null }> } | null } | { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } } | { __typename: 'ComponentSharedSpotlights' } | { __typename: 'ComponentSharedSpotlightsList' } | { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null } | { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> } | { __typename: 'ComponentSharedTextBlock', id: string, text: string } | { __typename: 'ComponentSharedWorkoutsSwimline', expand?: boolean | null, workoutsAnchor?: string | null, workoutsTitle?: string | null, workouts?: { __typename?: 'WorkoutCardRelationResponseCollection', data: Array<{ __typename?: 'WorkoutCardEntity', id?: string | null, attributes?: { __typename?: 'WorkoutCard', duration?: any | null, durationType?: string | null, name?: string | null, rating?: number | null, segments?: {} | null, syncedAt?: string | null, tags?: {} | null, tss?: number | null, workoutId: any, workoutType?: string | null } | null }> } | null } | { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'Error' } | null> | null, localizations?: { __typename?: 'HomepageRelationResponseCollection', data: Array<{ __typename?: 'HomepageEntity', attributes?: { __typename?: 'Homepage', locale?: string | null } | null }> } | null } | null };

export type DefaultNavbarQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type DefaultNavbarQuery = { __typename?: 'Query', navbar?: { __typename?: 'Navbar', navbarSettings: { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } } | null };

export type PostsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id: string, title: string, slug: string, perex: string, publishedAt?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> };

export type PostQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  category: Enum_Post_Category;
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type PostQuery = { __typename?: 'Query', postBySlug?: { __typename?: 'Post', title: string, slug: string, perex: string, text: string, publishedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, paragraphs?: Array<{ __typename?: 'ComponentSharedParagraph', text?: string | null, youtubeLink?: string | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, localizations?: { __typename?: 'PostRelationResponseCollection', data: Array<{ __typename?: 'PostEntity', attributes?: { __typename?: 'Post', locale?: string | null } | null }> } | null } | null };

export type PostsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsSitemapQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', slug: string, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null, localizations?: { __typename?: 'PostRelationResponseCollection', data: Array<{ __typename?: 'PostEntity', attributes?: { __typename?: 'Post', locale?: string | null, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null } | null }> } | null }> };

export type RedirectQueryVariables = Exact<{
  source?: InputMaybe<Scalars['String']['input']>;
  publicationState: PublicationState;
}>;


export type RedirectQuery = { __typename?: 'Query', redirect?: { __typename?: 'Redirect', destination: string, permanent: boolean } | null };

export type StaticPageFragment = { __typename: 'StaticPage', title: string, text?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, localizations?: { __typename?: 'StaticPageRelationResponseCollection', data: Array<{ __typename?: 'StaticPageEntity', attributes?: { __typename?: 'StaticPage', locale?: string | null } | null }> } | null };

export type StaticPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type StaticPageQuery = { __typename?: 'Query', staticPage?: { __typename: 'StaticPage', title: string, text?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, localizations?: { __typename?: 'StaticPageRelationResponseCollection', data: Array<{ __typename?: 'StaticPageEntity', attributes?: { __typename?: 'StaticPage', locale?: string | null } | null }> } | null } | null };

export const ChallengesListItemFragmentDoc = gql`
    fragment ChallengesListItem on Challenge {
  id
  challengeId
  title
  description
  slug
  badgeToReward
  availableFrom
  availableTo
  expandTitle
  description
}
    `;
export const ChallengeEntityFragmentDoc = gql`
    fragment ChallengeEntity on ChallengeEntity {
  id
  attributes {
    ...ChallengesListItem
  }
}
    ${ChallengesListItemFragmentDoc}`;
export const ChallengeEntityResponseCollectionFragmentDoc = gql`
    fragment ChallengeEntityResponseCollection on ChallengeRelationResponseCollection {
  data {
    ...ChallengeEntity
  }
}
    ${ChallengeEntityFragmentDoc}`;
export const ChallengeEntityResponseFragmentDoc = gql`
    fragment ChallengeEntityResponse on ChallengeEntityResponse {
  data {
    ...ChallengeEntity
  }
}
    ${ChallengeEntityFragmentDoc}`;
export const ContentLayersFragmentDoc = gql`
    fragment ContentLayers on ComponentSharedContentLayers {
  aim
  perspective
  segment
  contentType
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment UploadFile on UploadFile {
  name
  url
  width
  height
  alternativeText
  mime
  formats
}
    `;
export const UploadFileEntityFragmentDoc = gql`
    fragment UploadFileEntity on UploadFileEntity {
  id
  attributes {
    ...UploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export const UploadFileEntityResponseFragmentDoc = gql`
    fragment UploadFileEntityResponse on UploadFileEntityResponse {
  data {
    ...UploadFileEntity
  }
}
    ${UploadFileEntityFragmentDoc}`;
export const ButtonFragmentDoc = gql`
    fragment Button on ComponentSharedButton {
  text
  link
  ctaEvent
  buttonStyle
  buttonType
}
    `;
export const UploadFileRelationResponseCollectionFragmentDoc = gql`
    fragment UploadFileRelationResponseCollection on UploadFileRelationResponseCollection {
  data {
    ...UploadFileEntity
  }
}
    ${UploadFileEntityFragmentDoc}`;
export const HeaderFragmentDoc = gql`
    fragment Header on ComponentSharedHeader {
  id
  headerAnchor: anchorId
  logo {
    ...UploadFileEntityResponse
  }
  textLogo
  headline
  subheading
  headerDescription: description
  headerButton: button {
    ...Button
  }
  buttonAlt {
    ...Button
  }
  video {
    ...UploadFileEntityResponse
  }
  cdnVideoUrl
  headerImage: image {
    ...UploadFileEntityResponse
  }
  responsiveImage {
    ...UploadFileEntityResponse
  }
  backgroundImage {
    ...UploadFileEntityResponse
  }
  logosStrip {
    ...UploadFileRelationResponseCollection
  }
  cdnBackgroundImageUrl
  headerCampaignId: campaignId
  linkAfterEmailSubmit
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on ComponentSharedQuestion {
  questionText
  answer
}
    `;
export const FaqFragmentDoc = gql`
    fragment Faq on ComponentSharedFaq {
  id
  faqAnchor: anchorId
  faqTitle: title
  question {
    ...Question
  }
  faqButton: button {
    ...Button
  }
}
    ${QuestionFragmentDoc}
${ButtonFragmentDoc}`;
export const ChallengePrizeFragmentDoc = gql`
    fragment ChallengePrize on ComponentWinnablePrize {
  title
  description
  image {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const PrizesFragmentDoc = gql`
    fragment Prizes on ComponentSharedPrizes {
  id
  prizesAnchor: anchorId
  prizesTitle: Title
  Prizes {
    ...ChallengePrize
  }
  Button {
    ...Button
  }
}
    ${ChallengePrizeFragmentDoc}
${ButtonFragmentDoc}`;
export const StepFragmentDoc = gql`
    fragment Step on ComponentSharedStepCard {
  image {
    ...UploadFileEntityResponse
  }
  alternativeImage {
    ...UploadFileEntityResponse
  }
  title
  description
  buttons {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const StepsFragmentDoc = gql`
    fragment Steps on ComponentSharedSteps {
  id
  stepsAnchor: anchorId
  stepsTitle: title
  alternativeTitle
  step {
    ...Step
  }
  stepsButton: button {
    ...Button
  }
  disableNumbering
}
    ${StepFragmentDoc}
${ButtonFragmentDoc}`;
export const NewsletterCtaFragmentDoc = gql`
    fragment NewsletterCta on ComponentSharedNewsletterCta {
  id
  newsletterCtaAnchor: anchorId
  ctaTitle: title
  description
  hint
  visual {
    ...UploadFileEntityResponse
  }
  campaignId
  newsletterCtaButtonLabel: buttonLabel
  formType
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const ContentCardFragmentDoc = gql`
    fragment ContentCard on ComponentSharedCard {
  contentTitle
  contentText
  contentImage {
    ...UploadFileEntityResponse
  }
  button {
    ...Button
  }
  buttonAlt {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const HighlightsFragmentDoc = gql`
    fragment Highlights on ComponentSharedHighlights {
  id
  highlightsAnchor: anchorId
  highlightsTitle: Title
  Layout
  Highlight {
    ...ContentCard
  }
}
    ${ContentCardFragmentDoc}`;
export const SimpleCtaFragmentDoc = gql`
    fragment SimpleCta on ComponentSharedSimpleCta {
  id
  simpleCtaAnchor: anchorId
  simpleCtaTitle: title
  simpleCtaDescription: description
  simpleCtaImage: image {
    ...UploadFileEntityResponse
  }
  simpleCtaButton: button {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const RouteCardFragmentDoc = gql`
    fragment RouteCard on RouteCard {
  ascendedMeters
  distanceMeters
  estimatedTimeSeconds
  name
  rating
  routeId
  simplifiedGeometryPoints
  stravaSegmentsCount
  thumbnailUrl
  description
}
    `;
export const RouteCardEntityFragmentDoc = gql`
    fragment RouteCardEntity on RouteCardEntity {
  id
  attributes {
    ...RouteCard
  }
}
    ${RouteCardFragmentDoc}`;
export const RouteCardEntityResponseFragmentDoc = gql`
    fragment RouteCardEntityResponse on RouteCardEntityResponse {
  data {
    ...RouteCardEntity
  }
}
    ${RouteCardEntityFragmentDoc}`;
export const EventInfoFragmentDoc = gql`
    fragment EventInfo on EventInfo {
  eventId
  id
  category
  locale
  longDescription
  subcategory
  title
  expandTitle
  type
  description
  mainPhoto {
    data {
      attributes {
        url
      }
    }
  }
  coverPhoto {
    data {
      attributes {
        url
      }
    }
  }
  routeCard {
    ...RouteCardEntityResponse
  }
  defaultSessionStartDateTimeUtc
  defaultSessionId
}
    ${RouteCardEntityResponseFragmentDoc}`;
export const EventInfoEntityRelationCollectionItemFragmentDoc = gql`
    fragment EventInfoEntityRelationCollectionItem on EventInfoRelationResponseCollection {
  data {
    id
    attributes {
      ...EventInfo
    }
  }
}
    ${EventInfoFragmentDoc}`;
export const EventsFragmentDoc = gql`
    fragment Events on ComponentSharedEvents {
  id
  eventsAnchor: anchorId
  eventsTitle: title
  button {
    ...Button
  }
  eventInfos {
    ...EventInfoEntityRelationCollectionItem
  }
  featuredEventInfos {
    ...EventInfo
  }
  filterEventInfos {
    ...EventInfo
  }
  category
  subcategory
  logosStrip {
    ...UploadFileRelationResponseCollection
  }
  featured
  inverted
  expand
}
    ${ButtonFragmentDoc}
${EventInfoEntityRelationCollectionItemFragmentDoc}
${EventInfoFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}`;
export const CompanionAppCtaFragmentDoc = gql`
    fragment CompanionAppCta on ComponentSharedCompanionAppCta {
  id
  companionAppCtaAnchor: anchorId
  companionAppCtaTitle: title
  companionAppCtaDescription: description
  companionAppCtaImage: image {
    ...UploadFileEntityResponse
  }
  buttons {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const PageNavigationFragmentDoc = gql`
    fragment PageNavigation on ComponentSharedPageNavigation {
  id
  pageNavTitle: title
  pageNavDescription: description
  buttons {
    ...Button
  }
  pageNavAnchor: anchorId
}
    ${ButtonFragmentDoc}`;
export const RegisterCtaFragmentDoc = gql`
    fragment RegisterCta on ComponentSharedRegisterCta {
  id
  registerCtaTitle: title
  registerCtaDescription: description
  image {
    ...UploadFileEntityResponse
  }
  registerCtaAnchor: anchorId
  registerCtaCampaignId: campaignId
  linkAfterEmailSubmit
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const NavbarFragmentDoc = gql`
    fragment Navbar on ComponentSharedNavbar {
  id
  navbarItems {
    title
    path
  }
  navbarAnchor: anchorId
}
    `;
export const LinksCarouselFragmentDoc = gql`
    fragment LinksCarousel on ComponentSharedLinksCarousel {
  id
  linksCarouselTitle: title
  items: LinksCarouselItem {
    title
    description
    image {
      ...UploadFileEntityResponse
    }
    url
    label
  }
  linksCarouselAnchor: anchorId
  linksCarouselButtonClickThrough: buttonClickThrough
  background
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const YoutubeVideoFragmentDoc = gql`
    fragment YoutubeVideo on ComponentSharedYouTubeVideo {
  id
  youTubeTitle: title
  youTubeAnchor: anchorId
  embedCode
  videoUrl
  caption
  cover {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const StripeFragmentDoc = gql`
    fragment Stripe on ComponentSharedStripe {
  id
  stripeTitle: title
  stripeAnchorId: anchorId
  titleSecondLine
  textColor
  backgroundColor
  upperBackgroundColor
  lowerBackgroundColor
}
    `;
export const TextBlockFragmentDoc = gql`
    fragment TextBlock on ComponentSharedTextBlock {
  id
  text
}
    `;
export const ChallengesFragmentDoc = gql`
    fragment Challenges on ComponentSharedChallenges {
  id
  challengesAnchor: anchorId
  challengesTitle: title
  challenges {
    data {
      id
      attributes {
        ...ChallengesListItem
      }
    }
  }
  expand
}
    ${ChallengesListItemFragmentDoc}`;
export const BlogPostListItemFragmentDoc = gql`
    fragment BlogPostListItem on BlogPost {
  title
  perex
  slug
  cover {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const BlogPostsFragmentDoc = gql`
    fragment BlogPosts on ComponentSharedBlogPosts {
  id
  blogPostsTitle: title
  blogPostsAnchor: anchorId
  blogPosts {
    data {
      attributes {
        ...BlogPostListItem
      }
    }
  }
  expand
}
    ${BlogPostListItemFragmentDoc}`;
export const VideoFragmentDoc = gql`
    fragment Video on ComponentSharedVideo {
  video {
    ...UploadFileEntityResponse
  }
  videoUrl
  thumbnail {
    ...UploadFileEntityResponse
  }
  autoPlay
  muted
  loop
  showControls
  showVideo
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const HeaderVideoFragmentDoc = gql`
    fragment HeaderVideo on ComponentSharedHeaderVideo {
  headline
  subheading
  headerVideoDescription: description
  buttons {
    ...Button
  }
  campaingId
  headerVideoAnchor: anchorId
  headerVideo: video {
    ...Video
  }
  headerVideoResponsive: videoResponsive {
    ...Video
  }
}
    ${ButtonFragmentDoc}
${VideoFragmentDoc}`;
export const PricingFragmentDoc = gql`
    fragment Pricing on ComponentSharedPricing {
  id
  pricingTitle: title
  pricingContent: content
  pricingAnchor: anchorId
  button {
    ...Button
  }
  yearlyToMonths
  monthly
  plan
  termsSection
  linkAfterEmailSubmit
}
    ${ButtonFragmentDoc}`;
export const ContentTeaserFragmentDoc = gql`
    fragment ContentTeaser on ComponentSharedContentTeaser {
  id
  teaserTitle: title
  teaserDescription: description
  teaserAnchor: anchorId
  size
  logo {
    ...UploadFileEntityResponse
  }
  logoResponsive {
    ...UploadFileEntityResponse
  }
  backgroundImage {
    ...UploadFileEntityResponse
  }
  backgroundImageResponsive {
    ...UploadFileEntityResponse
  }
  cards {
    cover {
      ...UploadFileEntityResponse
    }
    title
    description
    url
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const ProductsComparisonFragmentDoc = gql`
    fragment ProductsComparison on ComponentSharedProductsComparison {
  id
  productsComparisonTitle: title
  productsComparisonSubtitle: subtitle
  productsComparisonFeaturesTitle: featuresTitle
  productsComparisonAnchor: anchorId
  button {
    ...Button
  }
  productsJson
}
    ${ButtonFragmentDoc}`;
export const ChecklistFragmentDoc = gql`
    fragment Checklist on ComponentSharedChecklist {
  id
  checklistTitle: title
  checklistAnchor: anchorId
  checklistItems: items
  vertical
}
    `;
export const PlansSelectorFragmentDoc = gql`
    fragment PlansSelector on ComponentSharedPlansSelector {
  id
  plansSelectorTitle: title
  plansSelectorSubtitle: subtitle
  plansSelectorAnchor: anchorId
  button {
    ...Button
  }
  termsSection
}
    ${ButtonFragmentDoc}`;
export const TestimonialFragmentDoc = gql`
    fragment Testimonial on ComponentSharedTestimonial {
  testimonial
  author
  authorType
}
    `;
export const TestimonialsSectionFragmentDoc = gql`
    fragment TestimonialsSection on ComponentSharedTestimonialsSection {
  testimonials {
    ...Testimonial
  }
  testimonialsAnchor: anchorId
  autoscrollInterval
}
    ${TestimonialFragmentDoc}`;
export const LogoFragmentDoc = gql`
    fragment Logo on ComponentSharedLogo {
  id
  title
  image {
    ...UploadFileEntityResponse
  }
  link
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const LogoCloudsFragmentDoc = gql`
    fragment LogoClouds on ComponentSharedLogoClouds {
  id
  logoCloudsTitle: title
  logos {
    ...Logo
  }
}
    ${LogoFragmentDoc}`;
export const FeaturedLogoFragmentDoc = gql`
    fragment FeaturedLogo on ComponentSharedFeaturedLogo {
  id
  title
  featuredLogo: logo {
    ...Logo
  }
}
    ${LogoFragmentDoc}`;
export const RouteCardRelationResponseCollectionFragmentDoc = gql`
    fragment RouteCardRelationResponseCollection on RouteCardRelationResponseCollection {
  data {
    ...RouteCardEntity
  }
}
    ${RouteCardEntityFragmentDoc}`;
export const RoutesSwimlineFragmentDoc = gql`
    fragment RoutesSwimline on ComponentSharedRoutesSwimline {
  id
  routesTitle: title
  routesAnchor: anchorId
  logosStrip {
    ...UploadFileRelationResponseCollection
  }
  routes {
    ...RouteCardRelationResponseCollection
  }
  expand
}
    ${UploadFileRelationResponseCollectionFragmentDoc}
${RouteCardRelationResponseCollectionFragmentDoc}`;
export const WorkoutCardFragmentDoc = gql`
    fragment WorkoutCard on WorkoutCard {
  duration
  durationType
  name
  rating
  segments
  syncedAt
  tags
  tss
  workoutId
  workoutType
}
    `;
export const WorkoutCardEntityFragmentDoc = gql`
    fragment WorkoutCardEntity on WorkoutCardEntity {
  id
  attributes {
    ...WorkoutCard
  }
}
    ${WorkoutCardFragmentDoc}`;
export const WorkoutCardRelationResponseCollectionFragmentDoc = gql`
    fragment WorkoutCardRelationResponseCollection on WorkoutCardRelationResponseCollection {
  data {
    ...WorkoutCardEntity
  }
}
    ${WorkoutCardEntityFragmentDoc}`;
export const WorkoutsSwimlineFragmentDoc = gql`
    fragment WorkoutsSwimline on ComponentSharedWorkoutsSwimline {
  workoutsAnchor: anchorId
  expand
  workoutsTitle: title
  workouts {
    ...WorkoutCardRelationResponseCollection
  }
}
    ${WorkoutCardRelationResponseCollectionFragmentDoc}`;
export const HomepageBodyFragmentDoc = gql`
    fragment HomepageBody on HomepageBodyDynamicZone {
  __typename
  ...Header
  ...Faq
  ...Prizes
  ...Steps
  ...NewsletterCta
  ...Highlights
  ...SimpleCta
  ...Events
  ...CompanionAppCta
  ...PageNavigation
  ...RegisterCta
  ...Navbar
  ...LinksCarousel
  ...YoutubeVideo
  ...Stripe
  ...TextBlock
  ...Challenges
  ...BlogPosts
  ...HeaderVideo
  ...Pricing
  ...ContentTeaser
  ...ProductsComparison
  ...Checklist
  ...PlansSelector
  ...TestimonialsSection
  ...LogoClouds
  ...FeaturedLogo
  ...RoutesSwimline
  ...WorkoutsSwimline
}
    ${HeaderFragmentDoc}
${FaqFragmentDoc}
${PrizesFragmentDoc}
${StepsFragmentDoc}
${NewsletterCtaFragmentDoc}
${HighlightsFragmentDoc}
${SimpleCtaFragmentDoc}
${EventsFragmentDoc}
${CompanionAppCtaFragmentDoc}
${PageNavigationFragmentDoc}
${RegisterCtaFragmentDoc}
${NavbarFragmentDoc}
${LinksCarouselFragmentDoc}
${YoutubeVideoFragmentDoc}
${StripeFragmentDoc}
${TextBlockFragmentDoc}
${ChallengesFragmentDoc}
${BlogPostsFragmentDoc}
${HeaderVideoFragmentDoc}
${PricingFragmentDoc}
${ContentTeaserFragmentDoc}
${ProductsComparisonFragmentDoc}
${ChecklistFragmentDoc}
${PlansSelectorFragmentDoc}
${TestimonialsSectionFragmentDoc}
${LogoCloudsFragmentDoc}
${FeaturedLogoFragmentDoc}
${RoutesSwimlineFragmentDoc}
${WorkoutsSwimlineFragmentDoc}`;
export const TwoColumnsContentFragmentDoc = gql`
    fragment TwoColumnsContent on ComponentSharedTwoColumnsContent {
  twoColumnsContentTitle: title
  twoColumnsContentDescription: description
  twoColumnsContentText: text
  twoColumnsContentImage: image {
    data {
      attributes {
        url
      }
    }
  }
}
    `;
export const SeoFragmentDoc = gql`
    fragment SEO on ComponentSharedSeo {
  metaDescription
  metaTitle
  ogTitle
  noFollow
  noIndex
  shareImage {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const AuthorFragmentDoc = gql`
    fragment Author on Author {
  id
  name
  slug
  perex
  locale
  updatedAt
  jobTitle
  socialPlatform {
    type
    link
  }
  SEO {
    ...SEO
  }
  profilePhoto {
    data {
      attributes {
        name
        url
        width
        height
        alternativeText
        mime
        formats
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const AuthorsByTypeFragmentDoc = gql`
    fragment AuthorsByType on ComponentSharedAuthors {
  id
  authorsType: type
  authorsByType {
    ...Author
  }
}
    ${AuthorFragmentDoc}`;
export const HeaderAcceptInviteFragmentDoc = gql`
    fragment HeaderAcceptInvite on ComponentSharedHeaderAcceptInvite {
  id
  acceptInviteHeading: heading
  acceptInviteHeadingFallback: headingFallback
  acceptInviteSubheading: subheading
  acceptInviteSubheadingFallback: subheadingFallback
  acceptInviteButton: button {
    ...Button
  }
  acceptInviteButtonFallback: buttonFallback {
    ...Button
  }
  acceptInviteBackgroundImage: backgroundImage {
    ...UploadFileEntityResponse
  }
}
    ${ButtonFragmentDoc}
${UploadFileEntityResponseFragmentDoc}`;
export const DynamicPageBodyFragmentDoc = gql`
    fragment DynamicPageBody on DynamicPageBodyDynamicZone {
  __typename
  ...Header
  ...Faq
  ...Prizes
  ...Steps
  ...NewsletterCta
  ...Highlights
  ...SimpleCta
  ...Events
  ...CompanionAppCta
  ...PageNavigation
  ...RegisterCta
  ...Navbar
  ...LinksCarousel
  ...YoutubeVideo
  ...Stripe
  ...TextBlock
  ...Challenges
  ...BlogPosts
  ...HeaderVideo
  ...Pricing
  ...ContentTeaser
  ...ProductsComparison
  ...Checklist
  ...PlansSelector
  ...TestimonialsSection
  ...TwoColumnsContent
  ...LogoClouds
  ...FeaturedLogo
  ...AuthorsByType
  ...RoutesSwimline
  ...WorkoutsSwimline
  ...HeaderAcceptInvite
}
    ${HeaderFragmentDoc}
${FaqFragmentDoc}
${PrizesFragmentDoc}
${StepsFragmentDoc}
${NewsletterCtaFragmentDoc}
${HighlightsFragmentDoc}
${SimpleCtaFragmentDoc}
${EventsFragmentDoc}
${CompanionAppCtaFragmentDoc}
${PageNavigationFragmentDoc}
${RegisterCtaFragmentDoc}
${NavbarFragmentDoc}
${LinksCarouselFragmentDoc}
${YoutubeVideoFragmentDoc}
${StripeFragmentDoc}
${TextBlockFragmentDoc}
${ChallengesFragmentDoc}
${BlogPostsFragmentDoc}
${HeaderVideoFragmentDoc}
${PricingFragmentDoc}
${ContentTeaserFragmentDoc}
${ProductsComparisonFragmentDoc}
${ChecklistFragmentDoc}
${PlansSelectorFragmentDoc}
${TestimonialsSectionFragmentDoc}
${TwoColumnsContentFragmentDoc}
${LogoCloudsFragmentDoc}
${FeaturedLogoFragmentDoc}
${AuthorsByTypeFragmentDoc}
${RoutesSwimlineFragmentDoc}
${WorkoutsSwimlineFragmentDoc}
${HeaderAcceptInviteFragmentDoc}`;
export const BlogDynamicBodyFragmentDoc = gql`
    fragment BlogDynamicBody on BlogPostDynamicBodyDynamicZone {
  __typename
  ...Faq
  ...Prizes
  ...Steps
  ...NewsletterCta
  ...Highlights
  ...SimpleCta
  ...Events
  ...CompanionAppCta
  ...PageNavigation
  ...RegisterCta
  ...Navbar
  ...LinksCarousel
  ...YoutubeVideo
  ...Stripe
  ...TextBlock
  ...Challenges
  ...BlogPosts
  ...Pricing
  ...ProductsComparison
  ...Checklist
  ...PlansSelector
  ...TestimonialsSection
  ...TwoColumnsContent
  ...LogoClouds
  ...FeaturedLogo
  ...RoutesSwimline
  ...WorkoutsSwimline
}
    ${FaqFragmentDoc}
${PrizesFragmentDoc}
${StepsFragmentDoc}
${NewsletterCtaFragmentDoc}
${HighlightsFragmentDoc}
${SimpleCtaFragmentDoc}
${EventsFragmentDoc}
${CompanionAppCtaFragmentDoc}
${PageNavigationFragmentDoc}
${RegisterCtaFragmentDoc}
${NavbarFragmentDoc}
${LinksCarouselFragmentDoc}
${YoutubeVideoFragmentDoc}
${StripeFragmentDoc}
${TextBlockFragmentDoc}
${ChallengesFragmentDoc}
${BlogPostsFragmentDoc}
${PricingFragmentDoc}
${ProductsComparisonFragmentDoc}
${ChecklistFragmentDoc}
${PlansSelectorFragmentDoc}
${TestimonialsSectionFragmentDoc}
${TwoColumnsContentFragmentDoc}
${LogoCloudsFragmentDoc}
${FeaturedLogoFragmentDoc}
${RoutesSwimlineFragmentDoc}
${WorkoutsSwimlineFragmentDoc}`;
export const EventInfoEntityFragmentDoc = gql`
    fragment EventInfoEntity on EventInfoEntityResponse {
  data {
    id
    attributes {
      ...EventInfo
    }
  }
}
    ${EventInfoFragmentDoc}`;
export const NavbarSettingsFragmentDoc = gql`
    fragment NavbarSettings on ComponentSharedNavbarSettings {
  logoLink {
    url
    title
  }
  navLinks {
    url
    title
  }
  buttons {
    ...Button
  }
  transparent
  fixed
  secondaryLogo {
    ...UploadFileEntityResponse
  }
  secondaryLogoLink
}
    ${ButtonFragmentDoc}
${UploadFileEntityResponseFragmentDoc}`;
export const WorkoutCardEntityResponseFragmentDoc = gql`
    fragment WorkoutCardEntityResponse on WorkoutCardEntityResponse {
  data {
    ...WorkoutCardEntity
  }
}
    ${WorkoutCardEntityFragmentDoc}`;
export const BlogPostsListItemFragmentDoc = gql`
    fragment BlogPostsListItem on BlogPost {
  id
  title
  slug
  perex
  publishDate
  cover {
    ...UploadFileEntityResponse
  }
  SEO {
    ...SEO
  }
  author {
    data {
      attributes {
        name
        slug
        profilePhoto {
          ...UploadFileRelationResponseCollection
        }
      }
    }
  }
  blog_tags {
    data {
      id
      attributes {
        title
        slug
      }
    }
  }
  blog_category {
    data {
      attributes {
        title
        slug
      }
    }
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${SeoFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}`;
export const StaticPageFragmentDoc = gql`
    fragment StaticPage on StaticPage {
  __typename
  title
  text
  SEO {
    ...SEO
  }
  localizations {
    data {
      attributes {
        locale
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const AuthorBySlugDocument = gql`
    query AuthorBySlug($slug: String!) {
  authorBySlug(slug: $slug) {
    ...Author
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${AuthorFragmentDoc}`;
export const AuthorsDocument = gql`
    query Authors($sort: String, $limit: Int, $start: Int, $where: JSON) {
  authors(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...Author
  }
}
    ${AuthorFragmentDoc}`;
export const AuthorsSitemapDocument = gql`
    query AuthorsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON) {
  authors(sort: $sort, limit: $limit, start: $start, where: $where) {
    slug
    locale
    SEO {
      noIndex
    }
    updatedAt
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const BlogCategoriesDocument = gql`
    query BlogCategories($locale: String, $publicationState: PublicationState) {
  blogCategories(locale: $locale, publicationState: $publicationState) {
    id
    title
    slug
    SEO {
      ...SEO
    }
    locale
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const BlogCategoriesSitemapDocument = gql`
    query BlogCategoriesSitemap($locale: String, $publicationState: PublicationState) {
  blogCategories(locale: $locale, publicationState: $publicationState) {
    slug
    updatedAt
    SEO {
      noIndex
    }
    localizations {
      data {
        attributes {
          SEO {
            noIndex
          }
          updatedAt
          locale
        }
      }
    }
  }
}
    `;
export const BlogPostsDocument = gql`
    query BlogPosts($sort: String, $limit: Int, $start: Int, $where: JSON, $locale: String, $publicationState: PublicationState) {
  blogPosts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    locale: $locale
    publicationState: $publicationState
  ) {
    ...BlogPostsListItem
  }
}
    ${BlogPostsListItemFragmentDoc}`;
export const BlogPostsSitemapDocument = gql`
    query BlogPostsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON, $locale: String, $publicationState: PublicationState) {
  blogPosts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    locale: $locale
    publicationState: $publicationState
  ) {
    slug
    locale
    updatedAt
    SEO {
      noIndex
    }
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const BlogPostsSearchDocument = gql`
    query BlogPostsSearch($sort: String, $limit: Int, $start: Int, $where: JSON, $locale: String, $searchTerm: String, $publicationState: PublicationState) {
  blogPostsSearch(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    locale: $locale
    searchTerm: $searchTerm
    publicationState: $publicationState
  ) {
    ...BlogPostsListItem
  }
}
    ${BlogPostsListItemFragmentDoc}`;
export const BlogPostsBySlugDocument = gql`
    query BlogPostsBySlug($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  blogPostBySlug(
    slug: $slug
    locale: $locale
    publicationState: $publicationState
  ) {
    id
    title
    slug
    perex
    body
    publishDate
    structuredDataHeadline
    cover {
      ...UploadFileEntityResponse
    }
    SEO {
      ...SEO
    }
    author {
      data {
        id
        attributes {
          name
          slug
          perex
          locale
          updatedAt
          profilePhoto {
            ...UploadFileRelationResponseCollection
          }
        }
      }
    }
    blog_tags {
      data {
        id
        attributes {
          title
          slug
        }
      }
    }
    blog_category {
      data {
        id
        attributes {
          title
          slug
          locale
          updatedAt
          SEO {
            ...SEO
          }
        }
      }
    }
    dynamicBody {
      ...BlogDynamicBody
    }
    contentLayers {
      ...ContentLayers
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${SeoFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}
${BlogDynamicBodyFragmentDoc}
${ContentLayersFragmentDoc}`;
export const BlogTagBySlugDocument = gql`
    query BlogTagBySlug($slug: String!) {
  blogTagBySlug(slug: $slug) {
    id
    title
    slug
    SEO {
      ...SEO
    }
    locale
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const BlogTagsDocument = gql`
    query BlogTags($sort: String, $limit: Int, $start: Int, $where: JSON) {
  blogTags(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    title
    slug
    SEO {
      ...SEO
    }
  }
}
    ${SeoFragmentDoc}`;
export const BlogTagsSitemapDocument = gql`
    query BlogTagsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON) {
  blogTags(sort: $sort, limit: $limit, start: $start, where: $where) {
    slug
    SEO {
      noIndex
    }
    updatedAt
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const DynamicPageDocument = gql`
    query DynamicPage($path: String!, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  dynamicPageByPath(
    path: $path
    locale: $locale
    publicationState: $publicationState
  ) {
    title
    structuredDataHeadline
    publishedAt
    SEO {
      ...SEO
    }
    navbarSettings {
      ...NavbarSettings
    }
    body {
      ...DynamicPageBody
    }
    contentLayers {
      ...ContentLayers
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${NavbarSettingsFragmentDoc}
${DynamicPageBodyFragmentDoc}
${ContentLayersFragmentDoc}`;
export const DynamicPagesSitemapDocument = gql`
    query DynamicPagesSitemap($locale: String, $publicationState: PublicationState) {
  dynamicPage(locale: $locale, publicationState: $publicationState) {
    path
    locale
    SEO {
      noIndex
    }
    updatedAt
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const FooterLinkGroupsDocument = gql`
    query FooterLinkGroups($locale: I18NLocaleCode, $publicationState: PublicationState) {
  footer(locale: $locale, publicationState: $publicationState) {
    groups {
      title
      links {
        title
        url
      }
    }
    bottomLinks {
      title
      url
    }
  }
}
    `;
export const HomepageDocument = gql`
    query Homepage($variant: String!, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  homepage(
    variant: $variant
    locale: $locale
    publicationState: $publicationState
  ) {
    SEO {
      ...SEO
    }
    navbarSettings {
      ...NavbarSettings
    }
    body {
      ...HomepageBody
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${NavbarSettingsFragmentDoc}
${HomepageBodyFragmentDoc}`;
export const DefaultNavbarDocument = gql`
    query DefaultNavbar($locale: I18NLocaleCode, $publicationState: PublicationState) {
  navbar(locale: $locale, publicationState: $publicationState) {
    navbarSettings {
      ...NavbarSettings
    }
  }
}
    ${NavbarSettingsFragmentDoc}`;
export const PostsDocument = gql`
    query Posts($sort: String, $limit: Int, $start: Int, $where: JSON, $publicationState: PublicationState, $locale: String) {
  posts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    publicationState: $publicationState
    locale: $locale
  ) {
    id
    title
    slug
    perex
    publishedAt
    cover {
      data {
        ...UploadFileEntity
      }
    }
    SEO {
      ...SEO
    }
  }
}
    ${UploadFileEntityFragmentDoc}
${SeoFragmentDoc}`;
export const PostDocument = gql`
    query Post($slug: String!, $category: ENUM_POST_CATEGORY!, $publicationState: PublicationState, $locale: I18NLocaleCode) {
  postBySlug(
    slug: $slug
    publicationState: $publicationState
    category: $category
    locale: $locale
  ) {
    title
    slug
    perex
    text
    publishedAt
    SEO {
      ...SEO
    }
    paragraphs {
      text
      youtubeLink
      asset {
        data {
          ...UploadFileEntity
        }
      }
    }
    cover {
      data {
        ...UploadFileEntity
      }
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${UploadFileEntityFragmentDoc}`;
export const PostsSitemapDocument = gql`
    query PostsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON, $publicationState: PublicationState, $locale: String) {
  posts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    publicationState: $publicationState
    locale: $locale
  ) {
    slug
    updatedAt
    SEO {
      noIndex
    }
    localizations {
      data {
        attributes {
          SEO {
            noIndex
          }
          locale
          updatedAt
        }
      }
    }
  }
}
    `;
export const RedirectDocument = gql`
    query Redirect($source: String, $publicationState: PublicationState!) {
  redirect(publicationState: $publicationState, source: $source) {
    destination
    permanent
  }
}
    `;
export const StaticPageDocument = gql`
    query StaticPage($slug: String!, $publicationState: PublicationState, $locale: I18NLocaleCode) {
  staticPage(slug: $slug, publicationState: $publicationState, locale: $locale) {
    ...StaticPage
  }
}
    ${StaticPageFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AuthorBySlug(variables: AuthorBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuthorBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorBySlugQuery>(AuthorBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AuthorBySlug', 'query', variables);
    },
    Authors(variables?: AuthorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuthorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorsQuery>(AuthorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Authors', 'query', variables);
    },
    AuthorsSitemap(variables?: AuthorsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuthorsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorsSitemapQuery>(AuthorsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AuthorsSitemap', 'query', variables);
    },
    BlogCategories(variables?: BlogCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogCategoriesQuery>(BlogCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogCategories', 'query', variables);
    },
    BlogCategoriesSitemap(variables?: BlogCategoriesSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogCategoriesSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogCategoriesSitemapQuery>(BlogCategoriesSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogCategoriesSitemap', 'query', variables);
    },
    BlogPosts(variables?: BlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsQuery>(BlogPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPosts', 'query', variables);
    },
    BlogPostsSitemap(variables?: BlogPostsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsSitemapQuery>(BlogPostsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPostsSitemap', 'query', variables);
    },
    BlogPostsSearch(variables?: BlogPostsSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsSearchQuery>(BlogPostsSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPostsSearch', 'query', variables);
    },
    BlogPostsBySlug(variables: BlogPostsBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsBySlugQuery>(BlogPostsBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPostsBySlug', 'query', variables);
    },
    BlogTagBySlug(variables: BlogTagBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogTagBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogTagBySlugQuery>(BlogTagBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogTagBySlug', 'query', variables);
    },
    BlogTags(variables?: BlogTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogTagsQuery>(BlogTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogTags', 'query', variables);
    },
    BlogTagsSitemap(variables?: BlogTagsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogTagsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogTagsSitemapQuery>(BlogTagsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogTagsSitemap', 'query', variables);
    },
    DynamicPage(variables: DynamicPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DynamicPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DynamicPageQuery>(DynamicPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DynamicPage', 'query', variables);
    },
    DynamicPagesSitemap(variables?: DynamicPagesSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DynamicPagesSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DynamicPagesSitemapQuery>(DynamicPagesSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DynamicPagesSitemap', 'query', variables);
    },
    FooterLinkGroups(variables?: FooterLinkGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FooterLinkGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FooterLinkGroupsQuery>(FooterLinkGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FooterLinkGroups', 'query', variables);
    },
    Homepage(variables: HomepageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HomepageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomepageQuery>(HomepageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Homepage', 'query', variables);
    },
    DefaultNavbar(variables?: DefaultNavbarQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultNavbarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultNavbarQuery>(DefaultNavbarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultNavbar', 'query', variables);
    },
    Posts(variables?: PostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostsQuery>(PostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Posts', 'query', variables);
    },
    Post(variables: PostQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostQuery>(PostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Post', 'query', variables);
    },
    PostsSitemap(variables?: PostsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostsSitemapQuery>(PostsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PostsSitemap', 'query', variables);
    },
    Redirect(variables: RedirectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RedirectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RedirectQuery>(RedirectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Redirect', 'query', variables);
    },
    StaticPage(variables: StaticPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaticPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaticPageQuery>(StaticPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StaticPage', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;